import {
  EAuthTypes,
  EPlatformName,
  ETelematicsMethodType,
  IPlatform,
} from "../types";

export const PLATFORMS: IPlatform[] = [
  {
    key: "35dd54bb-394c-4f3c-a5c4-fae5c3d885f9",
    const: EPlatformName.WIALON,
    value: "35dd54bb-394c-4f3c-a5c4-fae5c3d885f9",
    label: "Wialon",
    sp_id: "10",
    methods: [
      {
        id: "1976ebac-7510-4fde-a446-f223a46f57d3",
        authorityType: EAuthTypes.OAUTH2,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "e05872fe-f283-4936-8f72-39a62ae2cb63",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "35dd54bb-394c-4f3c-a5c4-fae5c3d885f9",
    const: EPlatformName.GPS_COMMANDER,
    value: "35dd54bb-394c-4f3c-a5c4-fae5c3d885f9",
    label: "GPS Commander (FQ Wireless)",
    sp_id: "122",
    methods: [
      {
        id: "e05872fe-f283-4936-8f72-39a62ae2cb63",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://gpscommander.com",
        fixed_url: null,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl1.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5cf5fc28-d12c-4248-afb5-0bd7526cb203",
    const: EPlatformName.SAMSARA,
    value: "5cf5fc28-d12c-4248-afb5-0bd7526cb203",
    label: "Samsara",
    sp_id: "1",
    methods: [
      {
        id: "4c6e2f2c-88d8-4beb-9b06-dbbfa23bb7bd",
        authorityType: EAuthTypes.OAUTH2,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.samsara.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "4c6e2f2c-88d8-4beb-9b06-dbbfa23bb7bd",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.samsara.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.GEOTAB,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Geotab",
    sp_id: "2",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.ACTSOFT_ENCORE,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Actsoft Encore",
  //   sp_id: "38",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ADVANTAGE_ASSET_TRACKING,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Advantage Asset Tracking",
    sp_id: "67",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ARGOS_CONNECTED_SOLUTIONS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Argos Connected Solutions",
    sp_id: "148",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.ARI_FLEET,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "ARI Fleet",
  //   sp_id: "86",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ASSURED_TELEMATICS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Assured Telematics (GEOTAB)",
    sp_id: "78",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ATNT_FLEET,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "AT&T Fleet",
    sp_id: "138",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ATTRIX,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "AttriX",
    sp_id: "92",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.BADGER_FLEET_SOLUTIONS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Badger Fleet Solutions",
    sp_id: "76",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.BAR_CODING_CANADA,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "BarCoding Canada",
    sp_id: "149",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.BLUEARROW,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "BlueArrow",
    sp_id: "68",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.CARRIERHQ,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "CarrierHQ",
    sp_id: "69",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ENVUE_TELEMATICS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "EnVue Telematics",
    sp_id: "70",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.FLEET_NAV_SYSTEMS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Fleet Nav Systems",
    sp_id: "79",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.FLEET_PROFIT_CENTER,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Fleet Profit Center",
    sp_id: "77",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.FLEETBOSS_GPS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "FleetBoss GPS (GEOTAB)",
    sp_id: "71",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.FLEETHOSTER,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "FleetHoster",
    sp_id: "55",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.FLEETISTICS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Fleetistics",
    sp_id: "84",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.FLEETLOCATE_GEOTAB,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "FleetLocate (GEOTAB)",
    sp_id: "210",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.FLEETMASTER,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Fleetmaster (GEOTAB)",
    sp_id: "85",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "2fa4a7d6-1ea0-46f8-a6be-121b5f31cbed",
    const: EPlatformName.DICAN,
    value: "18e81c8e-2e59-423e-a9d4-74835bc3be3d",
    label: "DiCAN",
    sp_id: "66",
    methods: [
      {
        id: "a9ff6f3b-3a1b-47db-8486-471597b50ef8",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.FLEXPORT,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Flexport",
  //   sp_id: "151",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.GEOFORCE,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Geoforce",
  //   sp_id: "106",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.GLOSTONE,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Glostone",
    sp_id: "88",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.GOFLEET,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "GoFleet",
    sp_id: "90",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.GOGPS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "GoGPS",
    sp_id: "212",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.GPS_FLEET_FINDER,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "GPS Fleet Finder",
  //   sp_id: "80",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.GPS_SOLUTIONS,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "GPS Solutions",
  //   sp_id: "102",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.GPS_TRACKING_CANADA,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "GPS Tracking Canada",
    sp_id: "95",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.GRAYBOX_SOLUTIONS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Graybox Solutions",
    sp_id: "94",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.GRIDLINE,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Gridline",
    sp_id: "107",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.HIGHPOINT_GPS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "HighPoint GPS",
    sp_id: "101",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.IOTAB,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "IoTab",
    sp_id: "110",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.LYNX,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Lynx",
  //   sp_id: "93",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ONTRAK_SOLUTIONS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "OnTrak Solutions",
    sp_id: "99",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.PENSKE,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Penske (GEOTAB)",
    sp_id: "96",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.PREPASS_ELD,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "PrePass ELD",
  //   sp_id: "111",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.QUALITY_GPS,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Quality GPS",
  //   sp_id: "105",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.RMJ_TECHNOLOGIES,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "RMJ Technologies",
  //   sp_id: "100",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.RUSH_ENTERPRISES,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Rush Enterprises",
    sp_id: "81",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.RYDER,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Ryder",
    sp_id: "211",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.SAFETY_VISION,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Safety Vision (GEOTAB)",
    sp_id: "82",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.SHELL_TELEMATICS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Shell Telematics",
    sp_id: "354",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.SURECAM,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Surecam",
  //   sp_id: "127",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.T_MOBILE,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "T-Mobile",
    sp_id: "89",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.TRANSFLO,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Transflo",
    sp_id: "54",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.TRAXXISGPS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Traxxis GPS (GEOTAB)",
    sp_id: "73",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.VERTRAX,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Vertrax",
  //   sp_id: "91",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ZENDUIT,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Zenduit (GEOTAB)",
    sp_id: "108",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ADVANTAGE_ONE,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Advantage One (GEOTAB)",
    sp_id: "402",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.EAGLE_WIRELESS,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Eagle Wireless (GEOTAB)",
    sp_id: "233",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   const: EPlatformName.HOLMAN,
  //   value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
  //   label: "Holman",
  //   sp_id: "152",
  //   methods: [
  //     {
  //       id: "da75b399-451f-401f-a10e-d5bdce6f9259",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://my.geotab.com",
  //       fixed_url: false,
  //       check_connection: true,
  //     },
  //   ],
  // },
  {
    key: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    const: EPlatformName.ENTERPRISE_FLEET_MANAGEMENT,
    value: "c9a688d3-fee4-40c0-b283-c5ec3a75525e",
    label: "Enterprise Fleet Management (GEOTAB)",
    sp_id: "97",
    methods: [
      {
        id: "da75b399-451f-401f-a10e-d5bdce6f9259",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://my.geotab.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    const: EPlatformName.LINXUP,
    value: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    label: "Linxup",
    sp_id: "11",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.linxup.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "fb28b203-8399-4d4d-a701-210490bfe03b",
    const: EPlatformName.AWARE_GPS,
    value: "abea40d8-5699-405b-b7c1-8b6c787b1694",
    label: "Aware GPS",
    sp_id: "40",
    methods: [
      {
        id: "23aece56-d658-4b72-8322-00c3dbd09606",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.linxup.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3a2b6340-d736-4d84-9708-1adc95acb284",
    const: EPlatformName.COMMAND_GPS,
    value: "bd07a579-d613-427d-8f93-3980036db3e2",
    label: "Command GPS",
    sp_id: "57",
    methods: [
      {
        id: "2dfce13e-acc4-44e6-abde-50b1ab74d0b0",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.linxup.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    const: EPlatformName.FLEETSHARP,
    value: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    label: "FleetSharp",
    sp_id: "39",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.fleetsharp.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    const: EPlatformName.MOTIVE,
    value: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    label: "Motive (ex KeepTruckin)",
    sp_id: "3",
    methods: [
      {
        id: "4c6e2f2c-88d8-4beb-9b06-dbbfa23bb7bd",
        authorityType: EAuthTypes.OAUTH2,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.keeptruckin.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.keeptruckin.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    const: EPlatformName.ONE_STEP_GPS,
    value: "6d83733a-0209-4eea-a2de-1bd8fa201b3c",
    label: "One Step GPS",
    sp_id: "139",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.onestep.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf16",
    const: EPlatformName.TRIMBLE,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf16",
    label: "Trimble Transportation (Peoplenet)",
    sp_id: "20",
    methods: [
      {
        id: "2294609c-ceec-49b1-87db-438e4687183e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "http://oi.pfmlogin.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf16",
    const: EPlatformName.WAYLENS,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf16",
    label: "Waylens",
    sp_id: "326",
    methods: [
      {
        id: "2294609c-ceec-49b1-87db-438e4687183e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "http://waylens.com",
        fixed_url: false,
        check_connection: true,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e13683ea",
    const: EPlatformName.WEBFLEET,
    value: "2402e8f8-a751-46e7-93c7-7cb6e13683ea",
    label: "Webfleet",
    sp_id: "7",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://csv.webfleet.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.TEMPORARY_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
    const: EPlatformName.VERIZON,
    value: "2402e8f8-a751-46e7-93c7-7cdfsdfsdd",
    label: "Verizon Connect Reveal",
    sp_id: "4",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
    const: EPlatformName.GPS_INSIGHT,
    value: "2402e8f8-a751-46e7-93c7-7cdfsdfsdd",
    label: "GPS Insight",
    sp_id: "12",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbf54",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://gpsinsight.com",
        fixed_url: false,
        check_connection: false,
      },
      // TODO: for 2024 integration C0
      // {
      //   id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
      //   authorityType: EAuthTypes.ACCOUNT,
      //   url: "https://gpsinsight.com",
      //   fixed_url: false,
      //   check_connection: false,
      // },
    ],
  },
  {
    key: "b4891a84-a968-44b4-ab53-2c0cb6540a6d",
    const: EPlatformName.WEX_TELEMATICS,
    value: "bc8180f5-aaba-45bc-b3fa-4434d1411ebd",
    label: "WEX Telematics",
    sp_id: "60",
    methods: [
      {
        id: "9c3f66b3-0fef-4eb3-90fe-03038018fd09",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://gpsinsight.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
    const: EPlatformName.INSIGHT_MOBILE_DATA,
    value: "2402e8f8-a751-46e7-93c7-7cdfsdfsdd",
    label: "Insight Mobile Data",
    sp_id: "131",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f46dee18bbf54",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://insightmobiledata.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
    const: EPlatformName.MONARCH_GPS,
    value: "2402e8f8-a751-46e7-93c7-7cdfsdfsdd",
    label: "Monarch Tracking",
    sp_id: "142",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f46dee18bbf54",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://insightmobiledata.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
    const: EPlatformName.RHINO,
    value: "2402e8f8-a751-46e7-93c7-7cdfsdfsdd",
    label: "Rhino",
    sp_id: "359",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f46dee18bbf54",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://insightmobiledata.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
    const: EPlatformName.TOUCHTEL_GPS,
    value: "2402e8f8-a751-46e7-93c7-7cdfsdfsdd",
    label: "TouchTel GPS",
    sp_id: "156",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f46dee18bbf54",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://insightmobiledata.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
  //   const: EPlatformName.TRUCKSPY,
  //   value: "2402e8f8-a751-46e7-93c7-7cdfsdfsdd",
  //   label: "Truckspy",
  //   sp_id: "222",
  //   methods: [
  //     {
  //       id: "76d3ab91-549c-404c-a174-f46dee18bbf54",
  //       authorityType: EAuthTypes.TOKEN,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://insightmobiledata.com",
  //       fixed_url: false,
  //       check_connection: false,
  //     },
  //   ],
  // },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.MIX_TELEMATICS,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "MiX Telematics",
    sp_id: "9",
    methods: [
      {
        id: "2294609c-ceec-49b1-87db-438e46656455",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://mix-telematics.com",
        fixed_url: true,
        check_connection: true,
      },
    ],
  },
  {
    key: "5cf5fc28-d12c-4248-afb5-0bd7526cb203",
    const: EPlatformName.EROAD,
    value: "5cf5fc28-d12c-4248-afb5-0bd7526cb203",
    label: "EROAD",
    sp_id: "28",
    methods: [
      {
        id: "4c6e2f2c-88d8-4beb-9b06-dbbfa23bb7bd",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.eroad.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.FLEET_COMPLETE,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Fleet Complete",
    sp_id: "8",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://fleetcomplete.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "dad24d7a-1e7c-4690-839d-2e12c4cf196c",
    const: EPlatformName.TELUS,
    value: "418f5479-0d9a-48ce-9f1e-753666a20dda",
    label: "TELUS",
    sp_id: "56",
    methods: [
      {
        id: "b09400ff-7ff7-47ed-9e9e-a0d700462200",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://fleetcomplete.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "031795e1-16c2-4c3d-ad90-57238b6c1683",
    const: EPlatformName.BIGROAD,
    value: "0a87236e-1a5b-4af5-9b99-fdd6fbdaba6d",
    label: "Bigroad",
    sp_id: "51",
    methods: [
      {
        id: "493469f0-cc1b-4001-a385-6c3487e76d93",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://fleetcomplete.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.ATNT_FLEET_COMPLETE,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "AT&T (Fleet Complete)",
    sp_id: "53",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://attfleetcomplete.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.FLEET_UP,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "FleetUp",
    sp_id: "366",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://fleetup.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.LION_EIGHT,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "LionEight",
    sp_id: "224",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.lioneight.com",
        url: "https://eldrider.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.ELD_RIDER_PRO,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "ELD Rider Pro",
    sp_id: "214",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.eldriderpro.com",
        url: "https://eldrider.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.SHELD,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "SHELD",
    sp_id: "215",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.sheld.com",
        url: "https://eldrider.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.XELD,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "XELD",
    sp_id: "120",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.xeld.com",
        url: "https://cloud.xeld.us",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.ZELD,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "ZELD",
    sp_id: "140",
    methods: [
      {
        id: "937ed023-4642-4582-bb21-43b680ef5967",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://eldrider.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b4838b1b-34a2-4952-b159-bdf92c2586b1",
    const: EPlatformName.EVA_ELD,
    value: "b203fcc8-124e-46b6-a2d1-c5ad6654c61c",
    label: "EVA ELD",
    sp_id: "176",
    methods: [
      {
        id: "1f5fb768-aec7-4212-9d8b-6db3a6f280aa",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://cloud.evaeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "4e408321-9638-45d9-a6dd-0f511f4df6a3",
    const: EPlatformName.XPLORE_ELD,
    value: "8b0470a1-38ef-43a7-860f-a481e0dccf73",
    label: "Xplore ELD",
    sp_id: "174",
    methods: [
      {
        id: "f32a90a3-e1e4-4f08-8968-b17df8f5b2ed",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://cloud.xploreeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f1006ca1-4ccf-46c0-aa13-e33c15334b54",
    const: EPlatformName.OPTIMA_ELD,
    value: "8498e1a8-1f32-4696-90fb-86c42e155b6f",
    label: "Optima ELD",
    sp_id: "163",
    methods: [
      {
        id: "39f7cc3e-bc56-45f8-8e75-ad2740850e16",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://web.optimaeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ad18804d-3eb4-4276-a2bc-09d92d887c0d",
    const: EPlatformName.PRO_RIDE_ELD,
    value: "37d53e3c-ba90-4b66-8349-7a5f9cc748f8",
    label: "Pro Ride ELD",
    sp_id: "168",
    methods: [
      {
        id: "433ab248-5b06-4aed-8250-13e05d139095",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://web.prorideeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.LYTX,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Lytx",
    sp_id: "5",
    methods: [
      // {
      //   id: "4c6e2f2c-88d8-4beb-9b06-dbbf3bb7bd",
      //   authorityType: EAuthTypes.TOKEN,
      //   type: ETelematicsMethodType.PERMANENT_API,
      //   url: "https://api.lytx.com",
      //   fixed_url: true,
      //   check_connection: true,
      // },
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        type: ETelematicsMethodType.MANUAL,
        authorityType: EAuthTypes.ACCOUNT,
        url: "https://lytx.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.OMNITRACS,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Omnitracs ES",
    sp_id: "18",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        type: ETelematicsMethodType.MANUAL,
        authorityType: EAuthTypes.ACCOUNT,
        url: "https://omni.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.ISAAC,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Isaac Instruments",
    sp_id: "205",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.AZUGA,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Azuga",
    sp_id: "300",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://services.azuga.com",
        fixed_url: true,
        check_connection: true,
      },
    ],
  },
  {
    key: "0b244751-110c-4f96-884e-8aebe1ad2588",
    const: EPlatformName.AZUGA_ELD,
    value: "af7afc80-19fa-495f-ac33-91ca075bb7c4",
    label: "Azuga ELD (fka Vistracks)",
    sp_id: "356",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: true,
      },
    ],
  },
  // {
  //   key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   const: EPlatformName.WORKWAVE,
  //   value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   label: "Workwave (GPS heroes)",
  //   sp_id: "420",
  //   methods: [
  //     {
  //       id: "id",
  //       authorityType: EAuthTypes.ACCOUNT,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.NETRADYNE,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Netradyne",
    sp_id: "34",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   const: EPlatformName.NEXTRAQ,
  //   value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   label: "Nextraq",
  //   sp_id: "17",
  //   methods: [
  //     {
  //       id: "id",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.FLEETLOCATE_SPIREON_NSPIRE,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Fleet Locate 2.1 (Spireon NSpire)",
    sp_id: "52",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://spireon.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.XRS,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "XRS",
    sp_id: "43",
    methods: [
      {
        id: "76d3ab91-549c-404c-a174-f6dee18bbfca",
        type: ETelematicsMethodType.MANUAL,
        authorityType: EAuthTypes.ACCOUNT,
        url: "https://xrs.com",
        fixed_url: false,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "859031d1-74a5-46a1-8eff-d0758e456c66",
    const: EPlatformName.ZONAR,
    value: "b60501e4-3624-4857-9d34-97b02e5eb4f2",
    label: "Zonar",
    sp_id: "31",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   const: EPlatformName.ORBCOMM_ELD,
  //   value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   label: "Orbcomm (ELD)",
  //   sp_id: "19",
  //   methods: [
  //     {
  //       id: "id",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  // {
  //   key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   const: EPlatformName.ORBCOMM_BLUE_TREE,
  //   value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   label: "Orbcomm (BlueTree)",
  //   sp_id: "19",
  //   methods: [
  //     {
  //       id: "id",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  // {
  //   key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   const: EPlatformName.VISION_TRACK,
  //   value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
  //   label: "Vision Track",
  //   sp_id: "226",
  //   methods: [
  //     {
  //       id: "id",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.GORILLA_SAFETY,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    label: "Gorilla Safety",
    sp_id: "44",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "dbcf084b-b59f-47d6-ac7c-03c8eef8e5496",
    const: EPlatformName.CLUTCH_ELD,
    value: "dbcf084b-b59f-47d6-ac7c-03c8eef8e549",
    label: "Clutch ELD",
    sp_id: "113",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "0a2c3c65-e459-4d29-a0d0-751d37165375",
    const: EPlatformName.CYNTRX_ELD_PLUS,
    value: "0a2c3c65-e459-4d29-a0d0-751d37165375",
    label: "CyntrX ELD",
    sp_id: "114",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "99622150-1a01-47ae-9327-6cb34e71b06a",
    const: EPlatformName.ELD_MANDATE_PRO,
    value: "99622150-1a01-47ae-9327-6cb34e71b06a",
    label: "ELD Mandate Pro",
    sp_id: "118",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "b06f1a35-ac1e-467b-bf63-6bd9e9550e84",
  //   const: EPlatformName.FLEET_LOCATE_ELD,
  //   value: "b06f1a35-ac1e-467b-bf63-6bd9e9550e84",
  //   label: "FleetLocate ELD",
  //   sp_id: "146",
  //   methods: [
  //     {
  //       id: "id",
  //       authorityType: EAuthTypes.TOKEN,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //     {
  //       id: "id",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  {
    key: "3f0872d8-f1f4-4110-bc75-4078117e071c",
    const: EPlatformName.PATRIOT,
    value: "3f0872d8-f1f4-4110-bc75-4078117e071c",
    label: "Patriot ELD",
    sp_id: "358",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "862cdf05-4b4b-463e-9a23-b75ca0299d1c",
    const: EPlatformName.SIMPLEX_ELD,
    value: "862cdf05-4b4b-463e-9a23-b75ca0299d1c",
    label: "Simplex ELD",
    sp_id: "213",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3db28eb8-a326-4cde-ac76-bfe2db719147",
    const: EPlatformName.TRACK_ON_ELD,
    value: "3db28eb8-a326-4cde-ac76-bfe2db719147",
    label: "TrackOn ELD",
    sp_id: "144",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2da21978-55ac-4dd9-a5a7-225be988295c",
    const: EPlatformName.TRUCKER_PATH_ELD_PRO,
    value: "2da21978-55ac-4dd9-a5a7-225be988295c",
    label: "Trucker Path ELD Pro",
    sp_id: "134",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "536d249b-78d7-4e2a-a5d9-06d530027f10",
    const: EPlatformName.TELETRAC_NAVMAN,
    value: "536d249b-78d7-4e2a-a5d9-06d530027f10",
    label: "Teletrac Navman",
    sp_id: "135",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://csv.webfleet.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "a241cc8b-003f-420b-a83d-d49c36f7ebc5",
    const: EPlatformName.INTELLISHIFT,
    value: "67ad9c3e-532b-4781-b33a-161163d92c19",
    label: "Intellishift/VTS Silent Passenger",
    sp_id: "49",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: false,
        check_connection: true,
      },
    ],
  },
  {
    key: "e2d9ce97-f7c9-42cc-af7f-5c94c2ab9fec",
    const: EPlatformName.EZ_FLEET,
    value: "ee7ac130-1bc1-48f8-b2ec-55b853e43266",
    label: "EZ Fleet Tracking/Global Cloud Fleet",
    sp_id: "37",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: false,
        check_connection: true,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf77",
    const: EPlatformName.REQUEST,
    value: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf77",
    label: "Missing your provider?",
    sp_id: "136",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.REQUEST,
        type: ETelematicsMethodType.REQUEST_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },

  {
    key: "a4a5406d-5fd2-4593-b62a-0c2948184b07",
    const: EPlatformName.SIMPLE_TRUCK_ELD,
    value: "04e183aa-a2e5-45ee-a725-3d583917c59d",
    label: "Simple Truck ELD",
    sp_id: "35",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "1386cd79-9976-49c3-bd35-97a16f1263a6",
    const: EPlatformName.SIMPLE_E_LOG,
    value: "1e933427-c468-455b-bd65-ae2b76085155",
    label: "Simple E-log",
    sp_id: "145",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "a24fb7b2e-54b6-46f4-9dbe-321bcf6f4f3d",
    const: EPlatformName.GLOBAL_ELD,
    value: "199e8287-c3b0-47bb-96ae-9e8925dcb1a5",
    label: "Global ELD",
    sp_id: "121",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  {
    key: "eed1b018-590a-47b4-bf3b-240bedaa4951",
    const: EPlatformName.MICHELIN_CONNECTED_FLEET,
    value: "1a11d8e4-e96e-428b-9f9a-15fbdccddba2",
    label: "Michelin Connected Fleet",
    sp_id: "17",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f7a2c8e9-4d3b-4f8a-9e5c-7b6d8a1f2e3c",
    const: EPlatformName.NEXTRAQ_MARCUS,
    value: "b4e7f9a2-8c5d-4a6b-9f3e-2d7c8b1a5e4f",
    label: "Nextraq",
    sp_id: "405",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e6892932-8b2f-4837-9408-227a0ee4474a",
    const: EPlatformName.GPS_TRACKIT,
    value: "cb97fa85-39d1-4a61-b493-3821a528e926",
    label: "GPS Trackit",
    sp_id: "13",
    methods: [
      {
        id: "f3b0e833-0012-4c92-afe0-14dffc4b2592",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://cloud-api.gpstrackit.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c46a0ed3-67f4-4cec-8aca-bb978f2eb27c",
    const: EPlatformName.BRICKHOUSE_SECURITY,
    value: "3f0a4ae8-8802-4bd1-ad4b-045245486da8",
    label: "BrickHouse security",
    sp_id: "395",
    methods: [
      {
        id: "fce659db-66b2-4e59-8cb2-62837ae2341a",
        authorityType: EAuthTypes.OAUTH2,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "3a94610a-a372-494b-a7a2-0e86e57d870e",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "f19da19b-ce3f-465c-b9a4-132cf8cea987",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c4a75b46-834e-4dfa-a83d-0d38571affb0",
    const: EPlatformName.TERMINUS_GPS_ELD,
    value: "da399725-4ebe-41d4-b6d5-a7094b88d649",
    label: "Terminus GPS ELD",
    sp_id: "568",
    methods: [
      {
        id: "e25ba0c5-0d4d-45fc-9858-5bf36dca49ae",
        authorityType: EAuthTypes.OAUTH2,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "1de6ab82-0cab-40bf-a52e-e2cdabb73cb6",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "56379882-186e-4764-84af-9b3ed52e5fd5",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c774f3b8-1f2b-46c2-b70a-041195ce6124",
    const: EPlatformName.BRANIX,
    value: "d8c47be7-b6fa-4e60-b0d9-ba02a8cb3e21",
    label: "Branix",
    sp_id: "569",
    methods: [
      {
        id: "339cbb31-d6ae-45b9-8479-5c22ac233f3a",
        authorityType: EAuthTypes.OAUTH2,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "1cdc17d1-14e4-40b9-b758-fec7be9299f8",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hst-api.wialon.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "6a3932c9-190d-41fe-9492-b81692f0b720",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ca865a65-d811-481d-bc75-4b66b2ee5418",
    const: EPlatformName.BLUE_INK,
    value: "1279e52d-21ee-448d-9eac-f2e00a8b2254",
    label: "BlueInk Tech",
    sp_id: "115",
    methods: [
      {
        id: "65db8400-3be4-4288-8129-b853de33215f",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "b5d50884-7a3d-49d7-ac40-b3daa84e2ed3",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b4838b1b-34a2-4952-b159-bdf92c2586b11",
    const: EPlatformName.TX_ELD,
    value: "b203fcc8-124e-46b6-a2d1-c5ad6654c61c1",
    label: "TX ELD",
    sp_id: "173",
    methods: [
      {
        id: "1f5fb768-aec7-4212-9d8b-6db3a6f280aa",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://cloud.txeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b4838b1b-34a2-4952-b159-bdf92c2586b112",
    const: EPlatformName.POP_ELD,
    value: "b203fcc8-124e-46b6-a2d1-c5ad6654c61c12",
    label: "POP ELD",
    sp_id: "450",
    methods: [
      {
        id: "1f5fb768-aec7-4212-9d8b-6db3a6f280aa",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://cloud.popeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b4838b1b-34a2-4952-b159-bdf92c2586b13",
    const: EPlatformName.PEAK_ELD,
    value: "b203fcc8-124e-46b6-a2d1-c5ad6654c61c13",
    label: "PEAK ELD",
    sp_id: "457",
    methods: [
      {
        id: "b203fcc8-124e-46b6-a2d1-bdf92c2586b13",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        // url: "https://api.zeld.com",
        url: "https://cloud.eldpeak.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "id",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "fc5876a8-5b01-403a-837a-95258f927eb7",
    const: EPlatformName.SURFSIGHT,
    value: "4bfcde64-6e6c-4ae8-ac20-dcbd9ce17900",
    label: "Surfsight",
    sp_id: "204",
    methods: [
      {
        id: "75aee2de-18ff-47e8-963b-1dac35008fb6",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api-prod.surfsight.net",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // HOS Connect and resellers
  {
    key: "9e6a0b13-a17e-498b-a9b6-9eab870c4e7d",
    const: EPlatformName.HOS_247,
    value: "627cbc7e-6bbd-4105-b7a7-3029670eb727",
    label: "HOS 247",
    sp_id: "388",
    methods: [
      {
        id: "e75e1a5c-1525-4ee6-877c-a0f07f14cfb8",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.BLACK_BEAR_ELD,
    value: "b544d9b8-ce8e-4370-9bc8-88ab4fb37d7c",
    label: "Black Bear ELD",
    sp_id: "451",
    methods: [
      {
        id: "24699747-6663-4b55-9bc6-ef588fa183e5",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "1a976b66-7603-4f64-abcd-d7ec0f6b7a1c",
    const: EPlatformName.COLUMBUS_ELD,
    value: "ac68135d-03bd-4a11-833f-78b565a35f6b",
    label: "Columbus ELD",
    sp_id: "158",
    methods: [
      {
        id: "bed4ff04-14fc-4fd6-b7c2-2afbc42c0341",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "eaf09f38-2af6-458f-98fc-a8692efd2ea5",
    const: EPlatformName.STATE_ELOG,
    value: "a7b277d5-9a06-4e57-9abc-27046befa8f7",
    label: "State Elog",
    sp_id: "454",
    methods: [
      {
        id: "5cd4a208-00fa-42a5-942d-65e42485286d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "a0b48cd9-13d5-4fbf-9bf2-dd8b978f46ff",
    const: EPlatformName.DY_ELD,
    value: "b13f0a41-59e2-4daf-b8e7-1610b148ce77",
    label: "Dy ELD",
    sp_id: "186",
    methods: [
      {
        id: "40ec4a1c-8746-42de-a896-ef605e5d07d1",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c93f698c-06eb-4f17-a8c6-9ce7095e71ed",
    const: EPlatformName._3PL_TEK,
    value: "893f2521-f352-4f61-94c0-9ab2ad321979",
    label: "3pl Tek",
    sp_id: "36",
    methods: [
      {
        id: "27596641-4aee-4ca2-9684-5d82ef419eb6",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ceeac5fe-a9b1-4591-86e2-9b2d7c8e0676",
    const: EPlatformName.ABC_ELD,
    value: "aa114528-f5f3-4206-b0a3-d0518e65eb34",
    label: "Abc ELD",
    sp_id: "399",
    methods: [
      {
        id: "ac70bb3d-702f-4b83-ae44-fc3a73a59ca9",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "9404e95e-d597-43c9-8a91-a2a245c23f1f",
    const: EPlatformName.ACTION_ELD,
    value: "3c024f82-8594-4642-8fa9-8cf222ef35f8",
    label: "Action ELD",
    sp_id: "400",
    methods: [
      {
        id: "05f57dff-b235-44bb-9a34-d388ed523eeb",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3d26410d-9983-48f1-90ef-83a4b9b8cc73",
    const: EPlatformName.ADVANTAGE_KNIGHTS_ELD,
    value: "70d557a6-5965-4300-b8a7-9133019e192f",
    label: "Advantage Knights ELD",
    sp_id: "401",
    methods: [
      {
        id: "8d8b8d08-aa23-40e7-a817-3c2338c6bf1b",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "66b8dc29-918f-4485-9ab2-f5b57bfacda4",
    const: EPlatformName.ALPHA_E_LOGBOOK,
    value: "15badb37-e12a-463b-ad23-ff6fdd6980e8",
    label: "Alpha E Logbook",
    sp_id: "46",
    methods: [
      {
        id: "c3d14c7b-bfda-4ca7-8836-bacf18467547",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3c5161f3-c062-444f-bb9e-8af6d3c3ea14",
    const: EPlatformName.AMPM_ELD,
    value: "5c8ce852-47cf-4c40-bbd3-61795411145f",
    label: "AMPM ELD",
    sp_id: "453",
    methods: [
      {
        id: "770f6a00-f8b1-4f68-8394-7d31f3592b05",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "07a4d307-d36e-49d0-b52a-73715b2d46f5",
    const: EPlatformName.BISON_ELOG,
    value: "3e4c4ca8-20f4-4a28-ae81-74f3e616e176",
    label: "Bison Elog",
    sp_id: "268",
    methods: [
      {
        id: "ffcaacbc-6d2e-4716-9fc8-5a02a04219c5",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "1ad6eded-3977-4566-99bb-83d78968d07b",
    const: EPlatformName.CAPTAIN_ELD,
    value: "147fadde-0289-4bde-bd28-effc76af1e91",
    label: "Captain ELD",
    sp_id: "407",
    methods: [
      {
        id: "8870ba45-134b-4efa-a714-0947abe195f7",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ede1191b-d873-43b5-8834-a83fe5e5dd8c",
    const: EPlatformName.COBRA_ELD,
    value: "bcba6922-4b1c-45f6-b9bf-7c94f9b3da55",
    label: "Cobra ELD",
    sp_id: "109",
    methods: [
      {
        id: "37336f92-ab18-4d03-af2a-1ee308620b5f",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "fad84c05-4fe9-4d3b-bda5-053f5448fe37",
    const: EPlatformName.DAILY_ELD,
    value: "6ea7bfb2-2da5-465b-a9b8-7e8f433f186b",
    label: "Daily ELD",
    sp_id: "408",
    methods: [
      {
        id: "acc603d8-9977-4898-8b4c-947de34215e8",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "55044ade-f941-4c79-bbc5-edf7d8444fd3",
    const: EPlatformName.DFL_ELD,
    value: "e711f7a2-dbf9-4df2-a2bf-71ab86b2115f",
    label: "DFL ELD",
    sp_id: "269",
    methods: [
      {
        id: "04ec96f2-e864-4aa1-bafc-4a4fce1811a9",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "65feb6cb-06c5-4ebb-8a0d-cc04d86538eb",
    const: EPlatformName.DIGITAL_ELD,
    value: "82899eb3-28b1-48c7-8ed6-0fecea9bb90d",
    label: "Digital ELD",
    sp_id: "409",
    methods: [
      {
        id: "7be049ab-735e-46fd-96ff-af73f35f48f5",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c2e4fe2b-c5e5-48d9-80cc-c031259378b3",
    const: EPlatformName.DLOG_ELD,
    value: "d2bbeaac-fa63-4fec-b5df-01748c04354b",
    label: "Dlog ELD",
    sp_id: "410",
    methods: [
      {
        id: "d76f8dc3-f535-433d-9682-1d2d46febfd1",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "1ff84251-2ae8-4c0e-b83a-e2c6e37868de",
    const: EPlatformName.DYNAMIC_ELD,
    value: "7656f11a-d990-40fd-b0ef-41f56160654b",
    label: "Dynamic ELD",
    sp_id: "112",
    methods: [
      {
        id: "0b73926c-8e38-4695-bbb9-f4ccc8d5c17b",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "dbd02645-8ab6-4c72-8df8-c9b913579156",
    const: EPlatformName.EGREEN_ELD,
    value: "b7f84165-7fbe-4aed-8d7c-e046c7436e4a",
    label: "Egreen ELD",
    sp_id: "137",
    methods: [
      {
        id: "2530fb1e-3424-4988-9b42-86643b6b730e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "22c9b627-315c-49d1-b49b-27dc95aaac96",
    const: EPlatformName.ELD_FOR_YOU,
    value: "431f6992-dc7f-49b8-a3dc-5d4fd2f97eb5",
    label: "ELD For You",
    sp_id: "270",
    methods: [
      {
        id: "f54c958a-e1d1-4f96-aba4-02cb5f4d3bf1",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "619b79ed-36e6-44c3-aeb9-316b3572b4a2",
    const: EPlatformName.ELD2GO,
    value: "ce8169a1-f48b-4933-b1a1-d5e1faa99263",
    label: "ELD2Go",
    sp_id: "147",
    methods: [
      {
        id: "38086cd3-a227-43c4-bcdd-399982e80bf9",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ae8e3e8e-589f-4069-810a-b8d18336484f",
    const: EPlatformName.ELD4TRUCKING,
    value: "f9a264d8-317e-4c8a-ba5f-3646bf51ad4d",
    label: "ELD4Trucking",
    sp_id: "353",
    methods: [
      {
        id: "b5c3ccdd-a95c-432f-af1d-1224b7bebaf0",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "a8ae9fc1-c3ae-4d35-a2e5-3c35b52a43c8",
    const: EPlatformName.ELOG42,
    value: "cb27d15a-7732-4f17-b9c7-8055717576bd",
    label: "Elog42",
    sp_id: "271",
    methods: [
      {
        id: "1f1eb9eb-b36a-44a8-812c-4446a09ecbd3",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2da303b1-22fd-4421-bcaa-095af73c0e2f",
    const: EPlatformName.EXTREME_ELD,
    value: "60a4bda0-3ca5-4605-8904-ecaad93906f2",
    label: "Extreme ELD",
    sp_id: "154",
    methods: [
      {
        id: "c5a56329-3470-45e4-b454-26cd5c8e2c34",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "9cf02ee2-cc6c-4599-a93f-7ca7c4e74110",
    const: EPlatformName.FLASH_ELOGS,
    value: "6c04c618-d453-4783-abfe-075845680dce",
    label: "Flash Elogs",
    sp_id: "164",
    methods: [
      {
        id: "930f93ac-0ae8-4657-beb6-47066aea8b80",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ba47d768-6719-4546-bb4b-799fcd71a59f",
    const: EPlatformName.GLOBCOM_ELD,
    value: "b212514d-9225-45e8-ac3f-22b5404b9a8a",
    label: "Globcom ELD",
    sp_id: "165",
    methods: [
      {
        id: "56d76653-0837-4147-90b5-6097fac698b2",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade00d06-0fdb-468b-9949-6731ce4d0492",
    const: EPlatformName.HERO_ELD,
    value: "5d193874-ad0e-4ae7-bcf6-f8dcd792eda7",
    label: "Hero ELD",
    sp_id: "352",
    methods: [
      {
        id: "3b514a0c-0c7d-4002-8ac6-3bda1d4aa00e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e05cfd4d-6f76-4fd4-9431-3e759d4cbccb",
    const: EPlatformName.INFINITY_ELD,
    value: "d689bfd2-f663-49cd-8708-6e3679381482",
    label: "Infinity ELD",
    sp_id: "351",
    methods: [
      {
        id: "7acc6969-5ef6-47c7-89f9-691ef98221fc",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "253e1bab-d7d3-410b-a19a-0fb9b542e508",
    const: EPlatformName.IRONMAN_ELD,
    value: "197b1cd8-5375-45df-a7f8-51625f1619c8",
    label: "Ironman ELD",
    sp_id: "350",
    methods: [
      {
        id: "19177f08-6091-4c57-842b-557bbbdd8f5d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "29096764-ea9f-44eb-b2ab-60cda5caff40",
    const: EPlatformName.JUST_ELD,
    value: "35d67a67-1a66-4bba-892d-e86e54756ea7",
    label: "Just ELD",
    sp_id: "16",
    methods: [
      {
        id: "7d99a314-88e2-4a15-9d0f-76355764fec6",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "4bbb92da-1af4-4cf1-8e9a-136f8d2eae1d",
    const: EPlatformName.LEGACY_ELD,
    value: "035085f4-f128-4292-b5e6-db2331a95488",
    label: "Legacy ELD",
    sp_id: "75",
    methods: [
      {
        id: "8590937e-6a81-4885-83d9-e611cc93eefc",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "16871af7-d20e-4280-91fb-3d0ef44d5196",
    const: EPlatformName.LOG_PLUS_ELD,
    value: "5ba404ce-e225-47ef-8b2f-5ee037e82651",
    label: "Log Plus ELD",
    sp_id: "21",
    methods: [
      {
        id: "76225212-9c3b-4c29-bd6c-c0d959bd1ad9",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "18b0a116-c5e2-44de-b2e6-132ec9c720ab",
    const: EPlatformName.MOONLIGHT_ELD,
    value: "182cd0dd-05c8-41b9-b5d1-cad60997cb16",
    label: "Moonlight ELD",
    sp_id: "169",
    methods: [
      {
        id: "e0050f46-f395-4113-bb8c-720bca56502f",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8b104804-6cff-4999-a479-c89006c68c76",
    const: EPlatformName.NOOR_ELD,
    value: "a8350cee-0d34-4aba-9571-de3306854aca",
    label: "Noor ELD",
    sp_id: "272",
    methods: [
      {
        id: "29e7026a-f19f-4722-8366-8a0cc7adceeb",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "7ccb381c-dd98-4155-bf38-36a7da7130a9",
    const: EPlatformName.NOVIO_ELD,
    value: "be4426a6-b7ea-4a5e-b255-9da8a99b6273",
    label: "Novio ELD",
    sp_id: "23",
    methods: [
      {
        id: "a49be4fc-7617-4614-b6aa-7a688aebe2cc",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "980d5ddb-fbff-4ed9-99f6-855d7da22401",
    const: EPlatformName.ORIENT_STAR_ELD,
    value: "b7b33a58-f254-47a7-aab1-7c771c3ac31d",
    label: "Orient Star ELD",
    sp_id: "24",
    methods: [
      {
        id: "634f7d12-0b1b-45c2-a3fc-0cd6eaadb75a",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5c134c42-889e-40f1-b794-c722f01c9de9",
    const: EPlatformName.PARAGON_ELD,
    value: "97311999-03b2-439e-8b91-7b05b7855474",
    label: "Paragon ELD",
    sp_id: "170",
    methods: [
      {
        id: "d0b56328-b7af-4600-9651-05485f117da7",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "7daefe7d-d370-461e-8e9c-83f2b7e3e426",
    const: EPlatformName.PHOENIX_ELD,
    value: "62f8630c-a6b2-4b1f-8793-be076fd6c197",
    label: "Phoenix ELD",
    sp_id: "25",
    methods: [
      {
        id: "586ae0d4-6427-409e-8316-289b8276cc68",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "26770f09-9b35-4342-98b7-ca4bf9cf3128",
    const: EPlatformName.PIONEER_ELD_SOLUTION,
    value: "ed62bd17-a1c2-4ff0-b0af-9894452f85ad",
    label: "Pioneer ELD Solution",
    sp_id: "171",
    methods: [
      {
        id: "12838e67-617e-4d01-8dca-6e5a8648330c",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c6091fb9-6415-46b9-8921-e9d5e1691b09",
    const: EPlatformName.POWERTRUCKS_ELD,
    value: "5b285be8-857d-48cc-bd03-f9b3c71affe3",
    label: "Powertrucks ELD",
    sp_id: "26",
    methods: [
      {
        id: "a538ce02-e36a-4356-955c-ef50b1f6de49",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "74cfd034-42cb-4a05-abfd-2792c02c8678",
    const: EPlatformName.PROJECT_ELD,
    value: "1e365cec-e420-4123-8369-a7782e5fa16e",
    label: "Project ELD",
    sp_id: "273",
    methods: [
      {
        id: "64b139f6-8274-4f7c-8100-88b6285dca68",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ae67bfc3-fb0e-40ed-b285-e62528acd6f5",
    const: EPlatformName.QUICK_ELOGS_ELD,
    value: "12a3ac9c-36c6-4f2a-b6d6-d300759525fb",
    label: "Quick Elogs ELD",
    sp_id: "27",
    methods: [
      {
        id: "716c3d67-9f5b-4edd-848b-db13b91cd5f4",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f8ab005b-be3b-4e51-9195-75468737a050",
    const: EPlatformName.RENAISSANCE_ELD,
    value: "e1d7ac5b-5822-4dd9-87a4-fe5884b32906",
    label: "Renaissance ELD",
    sp_id: "29",
    methods: [
      {
        id: "c407ba1c-2b6e-41d4-ab4a-ed0031e627c7",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "97f19102-e844-4047-8ae8-ae157b72ec17",
    const: EPlatformName.ROBINHOOD_ELD,
    value: "95aa3e09-44eb-400d-99ab-931e434ab620",
    label: "Robinhood ELD",
    sp_id: "30",
    methods: [
      {
        id: "8ab0011f-ea75-43a2-a3e8-5c90217f0a7f",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "0413f7bf-f920-4c96-8a30-bd1d70399f59",
    const: EPlatformName.ROUTE_ELD,
    value: "6848f558-e40a-4228-9b74-4710c601f816",
    label: "Route ELD",
    sp_id: "83",
    methods: [
      {
        id: "e43b84d8-e0dc-4eb9-956d-56d82e50bc19",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3451412e-f4bf-418b-81d2-3ca718abfbc7",
    const: EPlatformName.RUN_ELD,
    value: "a7be986a-ba64-4714-a419-eb4c3e11a9c8",
    label: "Run ELD",
    sp_id: "32",
    methods: [
      {
        id: "6e4e8417-68ea-43cb-b135-60251d450fc7",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "a56f7d4d-3ef4-4efc-a721-b23ba8c11488",
    const: EPlatformName.SBA_ELD,
    value: "2d698cba-f07d-4c85-803d-8ecc7278e63c",
    label: "SBA ELD",
    sp_id: "33",
    methods: [
      {
        id: "f13cadf2-cb93-4c90-9948-74fdc196f409",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3ffa0362-ef1a-43fc-811e-310d9ad522a9",
    const: EPlatformName.SF_ELD,
    value: "4a7fe4e5-dbc5-41ed-8bf6-0694c0072649",
    label: "SF ELD",
    sp_id: "179",
    methods: [
      {
        id: "d1087418-ee06-4512-8786-5e7b7782a899",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "41a9682d-e533-4096-abea-9ca4fcfb3334",
    const: EPlatformName.SIMBA_ELD,
    value: "e051e345-cf2d-4691-be91-98ebca4c0c3e",
    label: "Simba ELD",
    sp_id: "180",
    methods: [
      {
        id: "12a7d5b8-4779-4a52-a11f-9dae01bf91d6",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8358b140-604d-4031-8203-5d9e66bf7338",
    const: EPlatformName.SMART_CHOICE_LOGS,
    value: "c211f4b5-4552-445a-b568-f5039fa00398",
    label: "Smart Choice Logs",
    sp_id: "181",
    methods: [
      {
        id: "df78aa79-8fc3-4ab1-8911-15bbbdac879d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "cf2e749a-0f28-4e05-9f89-aaa4c17cfd50",
    const: EPlatformName.SPEEDLINE_ELD,
    value: "ab388174-0f59-4d09-9489-c06575217507",
    label: "Speedline ELD",
    sp_id: "182",
    methods: [
      {
        id: "6c797636-3458-4829-b2a5-604e44b2fdca",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "76939ca5-f9d2-4994-8148-40b07ac5cba2",
    const: EPlatformName.STARWAY_ELD,
    value: "bf7f83d6-4d2f-45cb-8d29-1edcfd559ea9",
    label: "Starway ELD",
    sp_id: "183",
    methods: [
      {
        id: "e7d3bb9e-2c6c-47b5-adc2-5359852e2334",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "12b1b311-5733-4586-93af-76c5a31d124b",
    const: EPlatformName.SUPPORT_ELD,
    value: "c00c138b-d25f-44b8-8654-34bfe85a7e86",
    label: "Support ELD",
    sp_id: "47",
    methods: [
      {
        id: "ed1b8721-7867-49f0-98ba-99675c6cf4ef",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "62a0f3bb-4bcb-4c7e-ad37-f3f19a26c4fd",
    const: EPlatformName.TEDDY_ELD,
    value: "18903bd7-003a-4c84-a632-526db26ba64e",
    label: "Teddy ELD",
    sp_id: "50",
    methods: [
      {
        id: "d2b99b9d-b713-4bed-93f2-f28524854993",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "570e88d9-adb3-4455-a811-6858b37fca9a",
    const: EPlatformName.TEMPUS_ELD,
    value: "9dbce12e-e07a-44b7-af80-0c00fb85206c",
    label: "Tempus ELD",
    sp_id: "58",
    methods: [
      {
        id: "f093a14a-0668-49f9-b9a2-b67ae9476e78",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c44d6de8-06d1-4559-9b02-1c3148889064",
    const: EPlatformName.TRUE_ROAD_ELD,
    value: "fd9b9f9d-17fe-4d0e-8a2e-3e30ffd00d24",
    label: "True Road ELD",
    sp_id: "87",
    methods: [
      {
        id: "257af3a7-4c38-44cd-8443-3e914d7f0b51",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "932434ac-86c0-4e37-b385-ab199813ca31",
    const: EPlatformName.TRUST_ELD,
    value: "b662cb0b-ebb0-453e-aa9f-e4150e981fdb",
    label: "Trust ELD",
    sp_id: "59",
    methods: [
      {
        id: "2a9353c4-0b20-4bfc-9774-b415a6a5f74a",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "00ffc1c8-b3c3-4fa7-8cd6-8220310e6d30",
    const: EPlatformName.UNDER_CONTROL_ELD,
    value: "86e0fc68-661d-4593-a51d-148658517805",
    label: "Under Control ELD",
    sp_id: "61",
    methods: [
      {
        id: "cd1aec41-1bf9-4bed-9859-dd0164de5fcf",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "6abe2993-62db-42f2-aaa7-b58569160436",
    const: EPlatformName.UNITY_ELD,
    value: "fa307d16-ae76-4ad0-9167-7c1f6d825178",
    label: "Unity ELD",
    sp_id: "62",
    methods: [
      {
        id: "6f745e3f-432f-4459-8e3a-80faf8ef2734",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "4178c5f0-8405-4c51-af70-ff3ccc556576",
    const: EPlatformName.VLOG_ELD,
    value: "397a4d96-9213-4cbd-be51-ce11b130e1ae",
    label: "Vlog ELD",
    sp_id: "63",
    methods: [
      {
        id: "0a1bd2b0-0546-4c52-aa3a-bc8d9aa545e3",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3b42482b-1478-48a6-8eba-a0b2a39e6f71",
    const: EPlatformName.XPERT_LOGS,
    value: "3c50bf1d-090d-47d2-b92e-6b395e4f33d4",
    label: "Xpert Logs",
    sp_id: "72",
    methods: [
      {
        id: "87e92c05-35b4-4111-80ef-3556e70f6ff0",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b48f5bf5-ac44-44e1-9053-4773570c6bcb",
    const: EPlatformName.YOULOG_ELD,
    value: "a845eeb1-7533-4a94-aeff-ef861bda97de",
    label: "Youlog ELD",
    sp_id: "64",
    methods: [
      {
        id: "efd5da08-40ea-44d1-9859-a0fea61f493a",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "43773e21-f1ab-4193-8750-557b1a5ca57a",
    const: EPlatformName.ZAPHIRA_ELD,
    value: "85a05a06-7e86-4bee-8501-160f30d30022",
    label: "Zaphira ELD",
    sp_id: "65",
    methods: [
      {
        id: "730f526c-cbe8-4a38-86b9-e7150f5708c8",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "fd0523ce-9e89-4437-b448-b2cd0e5d339e",
    const: EPlatformName.EBLUE_SUN_LOGS,
    value: "29e4042b-c273-4981-af27-b20b6f8e02cb",
    label: "Eblue Sun Logs",
    sp_id: "187",
    methods: [
      {
        id: "a98a299f-92fb-4c0c-866c-ae6b9b4cf824",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "77013e58-376b-4c36-9a9c-fe6103ad9e24",
    const: EPlatformName.ELD_DESIRED,
    value: "05be9125-d2fd-40d1-a64e-ec29049db035",
    label: "ELD Desired",
    sp_id: "141",
    methods: [
      {
        id: "e87aa081-d670-446d-bbe7-069256d0bc65",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "82990fb8-8cc8-46ac-971e-44f77fa4f438",
    const: EPlatformName.FIRSTGATE_ELD,
    value: "9ad884c5-854a-4241-b984-5380ed498d08",
    label: "Firstgate ELD",
    sp_id: "160",
    methods: [
      {
        id: "bfba3072-d1a5-41b7-8ecb-d070a2d32e52",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8cd08f4d-f30b-41de-869f-c4083ab844d6",
    const: EPlatformName.GRAND_ELD,
    value: "d7652b0c-d456-4bd9-b754-2e351b9d8839",
    label: "Grand ELD",
    sp_id: "166",
    methods: [
      {
        id: "0bd6ccf3-07de-40cf-a3ba-836df141a0cc",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "aaa5731a-8e3d-4dc1-bb11-029a6293dfe7",
    const: EPlatformName.ILOG_ELD,
    value: "39120938-7100-408c-9e2f-f27ac9a0d91d",
    label: "Ilog ELD",
    sp_id: "167",
    methods: [
      {
        id: "efb5aca4-8e2d-48f7-abba-70357e216b02",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8755fc50-e597-4169-955e-fc8f79c110c7",
    const: EPlatformName.PLATINUM_ELD,
    value: "cf42067f-9a35-4dbc-add1-44644c5c1a50",
    label: "Platinum ELD",
    sp_id: "172",
    methods: [
      {
        id: "00847e01-967b-4315-91af-1015bbc4bad2",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "157f2d3b-8fd2-4f83-ad0f-0cef923e65a2",
    const: EPlatformName.READYSETPIPE_ELD,
    value: "905b2b2e-eb91-4c20-ad29-1176c6ff845b",
    label: "Readysetpipe ELD",
    sp_id: "175",
    methods: [
      {
        id: "54f8865f-3a6c-47fb-b1ad-7c2d180d6fb8",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "9cfc969d-95e7-462d-8eeb-d71a027be4bb",
    const: EPlatformName.RED_FOX_ELD,
    value: "50ab79e2-43bf-47fb-9252-1dfde0991b6a",
    label: "Red Fox ELD",
    sp_id: "177",
    methods: [
      {
        id: "4635ce6c-44f2-49cd-ae80-ebf79b3868df",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "120303d3-e4a4-4a2b-8985-6609e055bff2",
    const: EPlatformName.REGULOG_ELD,
    value: "a0e0c3a0-0c9a-4a3c-be0c-5ba31dd187f8",
    label: "Regulog ELD",
    sp_id: "178",
    methods: [
      {
        id: "0a7ba0be-6f44-415a-9632-d1738bce2ae3",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f8f210e0-40bc-4edb-b75a-dd80e3ff9a01",
    const: EPlatformName.SUBSET_LOGBOOK,
    value: "7bbabe05-36fe-48b6-b6be-d713285f93be",
    label: "Sunset Logbook",
    sp_id: "184",
    methods: [
      {
        id: "14d0bc03-0853-4231-a86e-bf25ec7bda42",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "dff3c951-c492-4c35-b75d-7e6382568812",
    const: EPlatformName.UNIQUE_ELD,
    value: "531adb88-22dd-45ca-a2f2-10a7bb5b37f1",
    label: "Unique ELD",
    sp_id: "185",
    methods: [
      {
        id: "ab5be781-70a6-4697-98f2-0e6b17b676ff",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "269436b1-2f91-4691-b934-047b0b69f9cd",
    const: EPlatformName.TOP_COMPLIANCE_ELD,
    value: "09edb1ab-25d0-4337-8ef3-a1cd34925335",
    label: "Top Compliance ELD",
    sp_id: "456",
    methods: [
      {
        id: "665a4eba-6c8b-4db9-b58b-66aa947f2a4a",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ad9f6af5-391b-4e52-b35d-e6c0ba7ed281",
    const: EPlatformName.OMEGA_ELD,
    value: "c1fc1554-725d-4273-af31-6e8b4c781df0",
    label: "Omega ELD",
    sp_id: "250",
    methods: [
      {
        id: "e251c977-f1cd-4ca7-a707-08931efb6252",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f76103a5-f983-400b-9bc2-425e756a1168",
    const: EPlatformName.MATRACK,
    value: "6dcc7c9c-062d-494b-8c73-dbd1d1a66abd",
    label: "Matrack",
    sp_id: "373",
    methods: [
      {
        id: "a6b3b67a-43e4-4e33-9c01-97e949645590",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.matrack.live",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "08ca43a4-9037-4168-b02f-f358f65c639b",
    const: EPlatformName.VESTIGE,
    value: "90989164-c0e7-4437-84fd-0e967f595656",
    label: "Vestige",
    sp_id: "459",
    methods: [
      {
        id: "e9a96240-8ef2-44ad-a0c1-82da57730a9f",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "api.vestigeview.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c8e7f6a5-4b3c-4d2e-9f1a-0b1c2d3e4f5a",
    const: EPlatformName.GTS,
    value: "c8e7f6a5-4b3c-4d2e-9f1a-0b1c2d3e4f5a",
    label: "Genuine Tracking Solutions (GTS)",
    sp_id: "465",
    methods: [
      {
        id: "d9e8f7a6-5c4b-4e3d-0a2b-1c2d3e4f5a6b",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://mdvr.api.genuinetracking.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // GPSTAB resellers
  {
    key: "b1c8e5f2-4a3d-4e91-9f0c-7d2a6b8e1c4f",
    const: EPlatformName.GPSTAB,
    value: "b1c8e5f2-4a3d-4e91-9f0c-7d2a6b8e1c4f",
    label: "GPSTab",
    sp_id: "123",
    methods: [
      {
        id: "a2d9f6e3-5b4e-5f02-a0d1-8e3b7c9f2d5a",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.gpstab.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "b3e0a7f4-6c5f-6013-b1e2-9f4c8d0a3e6b",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.gpstab.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c4f1b8a5-7d6a-7124-c2f3-a05d9e1b4f7c",
    const: EPlatformName.MAX_ELD,
    value: "c4f1b8a5-7d6a-7124-c2f3-a05d9e1b4f7c",
    label: "Max ELD",
    sp_id: "103",
    methods: [
      {
        id: "d5a2c9b6-8e7b-8235-d3a4-b16e0f2c5a8d",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.maxeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e6b3d0c7-9f8c-9346-e4b5-c27f1a3d6b9e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.maxeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f7c2e9d8-a09d-8457-f5c6-d38a2b4e7c0f",
    const: EPlatformName.MOUNTAIN_ELD,
    value: "f7c2e9d8-a09d-8457-f5c6-d38a2b4e7c0f",
    label: "Mountain ELD",
    sp_id: "104",
    methods: [
      {
        id: "a8d3f0e9-b1a0-9568-a6d7-e49b3c5f8d1a",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.mountaineld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "b9e4a1f0-c2b1-a679-b7e8-f5a04d6a9e2b",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.mountaineld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c0f5b2a3-d3c2-b78a-c8f9-a61b5e7a0d2c",
    const: EPlatformName.ELD_ONE,
    value: "c0f5b2a3-d3c2-b78a-c8f9-a61b5e7a0d2c",
    label: "ELD One",
    sp_id: "117",
    methods: [
      {
        id: "d1a6c3b4-e4d3-c89b-d9a0-b72c6f8b1e3d",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.eldone.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e2b7d4c5-f5e4-d90c-e0b1-c83d7a9c2f4e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.eldone.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f3c8e5d6-a7f6-e01d-f1c2-d94e8b0d3a5f",
    const: EPlatformName.ROADSTAR_ELD,
    value: "f3c8e5d6-a7f6-e01d-f1c2-d94e8b0d3a5f",
    label: "Roadstar ELD",
    sp_id: "125",
    methods: [
      {
        id: "a4d9f6e7-b8a7-f12e-a2d3-e05f9c1e4b6a",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.roadstareld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "b5e0a8f8-c9b8-a23f-b3e4-f16a0d2f5c7b",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.roadstareld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c6f1d8e9-d0c9-b34a-c4e5-a72f0e4b6c8d",
    const: EPlatformName.MASTER_ELD,
    value: "c6f1d8e9-d0c9-b34a-c4e5-a72f0e4b6c8d",
    label: "Master ELD",
    sp_id: "126",
    methods: [
      {
        id: "d7a2e9f0-e1d0-c45b-d5f6-b83a1f5c7d9e",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.mastereld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e8b3f0a1-f2e1-d56c-e6a7-c94b2a6d8e0f",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.mastereld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f9c4a3b2-e5f4-c67d-f7d8-e80b3f6d9a1f",
    const: EPlatformName.REAL_ELD,
    value: "f9c4a3b2-e5f4-c67d-f7d8-e80b3f6d9a1f",
    label: "Real ELD",
    sp_id: "129",
    methods: [
      {
        id: "a0d5b4c3-f6a5-d78e-a8e9-f91c4a7e0b2a",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.realeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "b1e6c5d4-a7b6-e89f-b9f0-a02d5b8f1c3b",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.realeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c2f7d6e5-b8c7-f90e-c3a4-d13e6a8f2b4c",
    const: EPlatformName.TFM_ELD,
    value: "c2f7d6e5-b8c7-f90e-c3a4-d13e6a8f2b4c",
    label: "TFM ELD",
    sp_id: "133",
    methods: [
      {
        id: "d3a8e7f6-c9d8-a01f-d4b5-e24f7b9a3c5d",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.tfmeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e4b9f8a7-d0e9-b12a-e5c6-f35a8c0b4d6e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.tfmeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f5c0a9b8-e1d0-a23b-f6d7-f46b9d1c5e7f",
    const: EPlatformName.FM_ELD,
    value: "f5c0a9b8-e1d0-a23b-f6d7-f46b9d1c5e7f",
    label: "FM ELD",
    sp_id: "162",
    methods: [
      {
        id: "a6d1b0c9-f2e1-b34c-a7e8-a57c0e2d6f8a",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.fmeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "b7e2c1d0-a3f2-c45d-b8f9-b68d1f3e7a9b",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.fmeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c8f3e2d1-b4a3-d56e-c9f0-d79e2a4f8b0c",
    const: EPlatformName.LIGHT_AND_TRAVEL_ELD,
    value: "c8f3e2d1-b4a3-d56e-c9f0-d79e2a4f8b0c",
    label: "Light & Travel ELD",
    sp_id: "463",
    methods: [
      {
        id: "d9a4f3e2-c5b4-e67f-d0a1-e80b3c5a9d1e",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.lightandtraveleld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e0b5a4f3-d6c5-f78a-e1b2-f91c4d6b0e2f",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.lightandtraveleld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "a1f6e5d4-c7b6-a89f-b2c3-a02f5d7e1b3a",
    const: EPlatformName.ID_ELD,
    value: "a1f6e5d4-c7b6-a89f-b2c3-a02f5d7e1b3a",
    label: "ID ELD",
    sp_id: "464",
    methods: [
      {
        id: "b2a7f6e5-d8c7-b90a-c3d4-b13a6e8f2c4b",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.ideld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "c3b8a7f6-e9d8-c01b-d4e5-c24b7f9a3d5c",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.ideld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5a6cffa6-ef57-43b8-a477-05c760fe0919",
    const: EPlatformName.NEO_ELD,
    value: "0b3895df-758f-4790-83ed-8d8731acbaad",
    label: "Neo ELD",
    sp_id: "559",
    methods: [
      {
        id: "9eb55d89-9683-4ffa-85a1-0e776d741e8e",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.neoeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "cc5f7e51-bd2a-4d30-b9ca-86589e2940e5",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.neoeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "64479544-a270-44ad-9311-eec33f65c465",
    const: EPlatformName.COGO_ELD,
    value: "154f9dc2-0bf2-428a-a9b7-2f83ef31fa38",
    label: "CoGo ELD",
    sp_id: "581",
    methods: [
      {
        id: "065c4378-6658-49c4-86f6-e49dfa038834",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.cogoeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "ad62dec1-e903-4246-a5ef-ccb40bd51090",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.cogoeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "18ff4f05-6659-4640-914c-706a6bd75059",
    const: EPlatformName.DIALOG_ELD,
    value: "49253e30-20a5-421d-9bcc-152e09d8be6a",
    label: "Dialog ELD",
    sp_id: "584",
    methods: [
      {
        id: "53b3017e-600c-4321-b8e1-6e7ea635e91a",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://app.dialogeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "1ae485a1-9f40-467d-8a7e-4d4051385fe7",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://app.dialogeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2402e8f8-a751-46e7-93c7-7cb6e1368dff",
    const: EPlatformName.ELITEGPS,
    value: "378297ce-1456-4418-9dc6-22dfbc6a4fdc",
    label: "Elite GPS",
    sp_id: "266",
    methods: [
      {
        id: "40da96e6-b9aa-4220-932d-98ba2cddc44c",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.MANUAL,
        url: "https://insightmobiledata.com",
        fixed_url: false,
        check_connection: false,
      },
    ],
  },
  // {
  //   key: "e6892932-8b2f-4837-9408-227a0ee4474a",
  //   const: EPlatformName.INTOUCH_GPS,
  //   value: "83118763-e3aa-431b-a955-3ac5cce5eff0",
  //   label: "Intouch GPS",
  //   sp_id: "41",
  //   methods: [
  //     {
  //       id: "cf69524c-93a8-4625-8046-1e11c24558e7",
  //       authorityType: EAuthTypes.TOKEN,
  //       type: ETelematicsMethodType.PERMANENT_API,
  //       url: "https://cloud-api.gpstrackit.com",
  //       fixed_url: true,
  //       check_connection: true,
  //     },
  //     {
  //       id: "1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d",
  //       authorityType: EAuthTypes.BASIC,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://someurl.com",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.SPARKLE_ELD,
    value: "3bd99cb1-aa3f-4d75-9efd-89826ecffda0",
    label: "Sparkle ELD",
    sp_id: "262",
    methods: [
      {
        id: "2f3a4b5c-6d7e-8f9a-0b1c-2d3e4f5a6b7c",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://sparkleeld.us/",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "8e2f202a-98ea-4262-97c8-8ccc8fa0fa46",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.APEX_ELD,
    value: "36b18f1e-7693-44ac-be2b-2e0bac0d22fc",
    label: "Apex ELD",
    sp_id: "404",
    methods: [
      {
        id: "39f0bc18-f514-47ad-846d-db082c3ca6b9",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "http://apexeld.us/",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "0f49ce8d-2c10-4b2a-8aed-134c5966ca75",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d45d1ef6-bc0d-4ff9-9874-bedd6a9ecf76",
    const: EPlatformName.ROCK_ELD,
    value: "876a8171-416c-4693-b9f2-8c7387001265",
    label: "Rock ELD",
    sp_id: "508",
    methods: [
      {
        id: "0435a251-9205-4c01-b01b-0c7aa2633cb7",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://rockeld.us/",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "eb003906-5fde-4f06-9523-eb8badba4f5c",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://someurl.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.RIDEHUB_ELD,
    value: "49056ec9-c8a1-4654-98c1-898c4ef77e2d",
    label: "Ridehub ELD",
    sp_id: "244",
    methods: [
      {
        id: "49056ec9-c8a1-4654-98c1-898c4ef77e2d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.TRACK_TRUCK,
    value: "93dfbc30-efa8-4649-9df4-c6debcfb5d3a",
    label: "Track Truck",
    sp_id: "467",
    methods: [
      {
        id: "93dfbc30-efa8-4649-9df4-c6debcfb5d3a",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.TRUCKSTAFF_ELD,
    value: "dbf3070c-e6e1-4f86-bd00-b54218887991",
    label: "Truckstaff ELD",
    sp_id: "468",
    methods: [
      {
        id: "dbf3070c-e6e1-4f86-bd00-b54218887991",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.DRAGON_ELD,
    value: "7be32236-55db-4723-a983-ef3dcde28711",
    label: "Dragon ELD",
    sp_id: "474",
    methods: [
      {
        id: "7be32236-55db-4723-a983-ef3dcde28711",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.FLEX_ELD,
    value: "3e879f40-f450-49aa-8c88-9cc3de114026",
    label: "Flex ELD",
    sp_id: "483",
    methods: [
      {
        id: "3e879f40-f450-49aa-8c88-9cc3de114026",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.HIGHEST_GEARS,
    value: "50c6be3e-a43f-4f41-b0c5-c78f92f538b1",
    label: "Highest Gears",
    sp_id: "488",
    methods: [
      {
        id: "50c6be3e-a43f-4f41-b0c5-c78f92f538b1",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.PDSYNC_ELD,
    value: "c4e84778-ad0d-4027-8bcd-0f36feadf51e",
    label: "PDSync ELD",
    sp_id: "496",
    methods: [
      {
        id: "c4e84778-ad0d-4027-8bcd-0f36feadf51e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ade4e0a7-9fe0-4a76-8900-386b7afee648",
    const: EPlatformName.TRUCK_FORD_ELD,
    value: "5abc0fbc-108b-4e26-9d32-ea90a3787db0",
    label: "Truck Ford ELD",
    sp_id: "505",
    methods: [
      {
        id: "5abc0fbc-108b-4e26-9d32-ea90a3787db0",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "458f6ce8-4882-4393-a9cc-c38e8fb71abf",
    const: EPlatformName.ASAP_ELD,
    value: "64c8aef4-0650-44c0-9de6-2e7dba94cabc",
    label: "Asap ELD",
    sp_id: "537",
    methods: [
      {
        id: "f5dae9cd-d113-48a2-8c6c-e3a1f2dc8496",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "a122de8b-ebe4-432e-a4bc-9753ac48542c",
    const: EPlatformName.EXTENDED_ROAD_ELD,
    value: "48c70497-9cff-4fcd-8990-77cc38077dc4",
    label: "Extended Road ELD",
    sp_id: "538",
    methods: [
      {
        id: "0c7a3d32-994a-41b0-a938-842b9fe814f9",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "11a7c08f-667c-4ece-a46b-45c345213869",
    const: EPlatformName.AUTOGRI_ELD,
    value: "1ad60f78-e6b6-4c1c-8ac5-f1ed6ea025cf",
    label: "Autogri ELD",
    sp_id: "539",
    methods: [
      {
        id: "9c868810-0a8b-42d0-8389-f947f4860a47",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ff296670-0b5b-494b-ba7d-209cbe7174a2",
    const: EPlatformName.AVANGUARD_ELD,
    value: "d178418d-a5d9-4601-902f-a257fb760149",
    label: "Avanguard ELD",
    sp_id: "540",
    methods: [
      {
        id: "4d3d61ac-83d1-4bc1-82ff-fd4f90f637b1",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "53dad34b-9f82-48cc-be3b-eb44a4e8b9e3",
    const: EPlatformName.AXIOS_ELD,
    value: "e3051983-ea2a-4574-a60f-829858cbe4b1",
    label: "Axios ELD",
    sp_id: "541",
    methods: [
      {
        id: "62edc7c8-9288-42ec-8acb-41b637e673e8",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e81a845d-8aaf-46f9-942e-eb50bb85554f",
    const: EPlatformName.BELLFAM_ELD,
    value: "d273397e-e8eb-4a9e-bc35-ed7d8f2a0e62",
    label: "Bellfam ELD",
    sp_id: "542",
    methods: [
      {
        id: "be56ecca-177e-42d4-a73c-65db768f616e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ff6ffe0c-9109-4ced-9761-c80fd8c7ee59",
    const: EPlatformName.BEST_SOURCE_ELD,
    value: "b68b5575-659a-4ac0-a299-168ebfb5ab96",
    label: "Best Source ELD",
    sp_id: "543",
    methods: [
      {
        id: "a4210d7c-ab12-436e-b974-eeb563f28d03",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "a86e22fe-f714-4a86-b9fb-9896e9381785",
    const: EPlatformName.BOLT_ELD,
    value: "2fb28169-742f-46a7-aee8-0af7fd523c30",
    label: "Bolt ELD",
    sp_id: "544",
    methods: [
      {
        id: "501b6bbb-0a62-4298-b29f-eb3453972c68",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "334ef4ae-8a8a-4af9-a88e-bfe2e92f9b7e",
    const: EPlatformName.DOCUDRIVE_ELD,
    value: "e0d7214b-db2e-4bc3-b000-6097bbcbb7eb",
    label: "Docudrive ELD",
    sp_id: "545",
    methods: [
      {
        id: "93cc5ed5-fd78-45ce-9749-fbb1519ed5a9",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "41656cd4-cc5a-4e05-8ee7-6ad35384f290",
    const: EPlatformName.RING_ELD,
    value: "15f06168-22fd-4482-8066-11cfe70c473f",
    label: "Ring ELD",
    sp_id: "546",
    methods: [
      {
        id: "9e4ce90b-aedf-42a1-b02c-843cc1c9dfc7",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "1745f8f3-5ce9-40eb-be3e-fc6a5d0a39b1",
    const: EPlatformName.EXPRESS_WAY_ELD,
    value: "13d10a24-7d8f-4349-85a9-1c01166b4a9a",
    label: "Express Way ELD",
    sp_id: "547",
    methods: [
      {
        id: "10e6237c-424e-41bf-8b91-b1e44bc51388",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2e6f2f03-2c8e-4954-84ac-a2259137825d",
    const: EPlatformName.LOOKTRUCK_ELD,
    value: "400a2626-63b5-4daa-bf4a-925294e7135e",
    label: "Looktruck ELD",
    sp_id: "548",
    methods: [
      {
        id: "8b2f08c0-ce95-43c5-90fc-33723517ac1d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2c40616a-3f04-4647-9dd1-28fe46bc04b4",
    const: EPlatformName.RS_ELD,
    value: "4665990a-5b83-4832-8f49-d90879643a51",
    label: "RS ELD",
    sp_id: "549",
    methods: [
      {
        id: "16b82c3d-9949-4f14-9ea4-fec554cb715d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ff96b546-221c-43f0-882e-3f8f69d2eace",
    const: EPlatformName.VRH_ELD,
    value: "6c972522-e0f2-4a2b-8dd1-90d356a2d687",
    label: "VRH ELD",
    sp_id: "550",
    methods: [
      {
        id: "6e0154bb-4d88-46c2-ac80-ce51ca82bf2d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "816e6244-1c8c-47f6-91f4-133e89dc30d8",
    const: EPlatformName.LOGS_SKI_ELD,
    value: "9947b88d-ff7f-4a5c-9cf4-709e9514a0ab",
    label: "Logs Ski ELD",
    sp_id: "551",
    methods: [
      {
        id: "dd38cc28-1be3-41f3-8caf-80df79d6687f",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e1758417-91ac-45ff-8c33-9eaad4a3d7a4",
    const: EPlatformName.TURNSBUSS,
    value: "a1b588e7-3ffa-4206-b41b-c06a474984d5",
    label: "Turnsbuss",
    sp_id: "552",
    methods: [
      {
        id: "d57fd126-80c7-42df-b8a7-351901ca78ef",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "86139361-8a7f-41a2-9c54-a0db48dc8ad9",
    const: EPlatformName.PREMIERRIDE_LOGS,
    value: "68c121ce-fede-437f-ad81-542982de7cf7",
    label: "Premierride Logs",
    sp_id: "553",
    methods: [
      {
        id: "580b9a64-15fa-4e28-8e1f-e67c568e8f22",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "0c9f92f4-5b5f-42fe-9b78-0f6d58955c10",
    const: EPlatformName.SIMPLEWAY_ELD,
    value: "810fe370-f7d3-4a21-9511-1158e23262aa",
    label: "Simpleway ELD",
    sp_id: "554",
    methods: [
      {
        id: "483638ad-a894-461c-a203-6a40e098ba0e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "4da44edf-4cf0-4993-b662-ba8eb587a335",
    const: EPlatformName.OZOD_EXPRESS_ELD,
    value: "ca99d64d-cc65-4f59-bad3-e648aa1a39ea",
    label: "Ozod Express ELD",
    sp_id: "555",
    methods: [
      {
        id: "ba8a40c6-4423-417b-bde6-26c3dfe84a3b",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8ca85923-58bc-4307-b778-ccfbfb71c19c",
    const: EPlatformName.MAP_ELOG,
    value: "0b1b15b7-e24d-4611-a514-c0b778af72bf",
    label: "Map Elog",
    sp_id: "556",
    methods: [
      {
        id: "52f38132-f790-4b56-92ce-caaf4cb8e5b3",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "029d6b19-e1eb-4fe4-ad87-85957bb5fd8d",
    const: EPlatformName.AM_LOGS_ELD,
    value: "0f31f193-ecdf-4597-a90f-92a6a0bd6bf4",
    label: "Am Logs ELD",
    sp_id: "557",
    methods: [
      {
        id: "6dde6b19-15a0-4450-9612-cb147001f65b",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f13b0d72-3c1a-45eb-a2cd-c9892a5dd085",
    const: EPlatformName._48_ELD,
    value: "d5bf6d4e-03d6-468d-bd33-57a545924bc8",
    label: "48 ELD",
    sp_id: "558",
    methods: [
      {
        id: "38038ed7-7291-450d-88e3-a11504ea4c51",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "0b97fc1a-f4b2-477d-ad60-509d584b6d52",
    const: EPlatformName.ROYAL_ELD,
    value: "95713c26-d862-43a3-8731-0e5783201823",
    label: "Royal ELD",
    sp_id: "578",
    methods: [
      {
        id: "b443b109-574c-430c-bc03-623eb56f557c",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "1dcfb2c7-1b27-49ee-9e5b-d6635ff45a03",
    const: EPlatformName.INSPIRE_ELD,
    value: "6c9ac4ba-0e8d-4752-8abf-66170dd57df0",
    label: "Inspire ELD",
    sp_id: "582",
    methods: [
      {
        id: "e5c40d81-00f2-4773-99d1-4630155eb4aa",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ac676ea4-0d44-4be8-bed8-b5d542d72d9b",
    const: EPlatformName.SPLIT_ELD,
    value: "c78ad2ec-1bf3-45de-9df6-773c42a66e05",
    label: "Split ELD",
    sp_id: "583",
    methods: [
      {
        id: "eda18dfb-f471-4b48-a24f-e461a18bedf1",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "511a0811-c9c9-4bc8-af00-708d0f581fd3",
    const: EPlatformName.ELD_ROAD_HOS,
    value: "b9f2b7b9-fe60-4425-95a5-38109ff0bcc3",
    label: "ELD Road",
    sp_id: "585",
    methods: [
      {
        id: "144b2a7b-61b4-4908-bbfd-ce16d1696836",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://developer.hosconnect.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // Trackensure resellers
  {
    key: "d6ab089e-49e4-48f8-ac35-96ee184b84a2",
    const: EPlatformName.TRACKENSURE,
    value: "d6ab089e-49e4-48f8-ac35-96ee184b84a2",
    label: "Trackensure",
    sp_id: "221",
    methods: [
      {
        id: "682f86f6-769a-43c1-86f7-1459c08f9649",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://trackensure.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "4ef0f663-0db8-4a73-baa4-e289d501e77f",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://trackensure.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "7be91da0-5c2d-46ec-b1f7-6ceeb6dec81e",
    const: EPlatformName.SWIFT_ELD,
    value: "7be91da0-5c2d-46ec-b1f7-6ceeb6dec81e",
    label: "Swift ELD",
    sp_id: "235",
    methods: [
      {
        id: "333e8637-0e25-4ed4-921f-ff23087e8e53",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://swifteld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "161be4e2-5229-478d-a9fa-2432452b363a",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://swifteld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "27726638-8e68-4132-ae4f-dd6b652e40c7",
    const: EPlatformName.SWITCHBOARD,
    value: "27726638-8e68-4132-ae4f-dd6b652e40c7",
    label: "Switchboard",
    sp_id: "384",
    methods: [
      {
        id: "21df0b6d-eb68-4067-8b30-d75e24ef8cc5",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://api.onswitchboard.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "69ec52b9-bd31-4587-b52e-9477db9a76cb",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.onswitchboard.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "cc1b624c-b336-4565-88f7-35fd0128a7d8",
    const: EPlatformName.AMBER_ELD,
    value: "cc1b624c-b336-4565-88f7-35fd0128a7d8",
    label: "Amber ELD",
    sp_id: "236",
    methods: [
      {
        id: "5ca9ba55-47cf-406a-a58f-b5f53d7803bb",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://ambereld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "802dd088-3732-4992-9347-6c95ddbcb6c0",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://ambereld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "77390b0e-8f26-4238-9a05-f40a6913df5b",
    const: EPlatformName.CLUB_ELD,
    value: "77390b0e-8f26-4238-9a05-f40a6913df5b",
    label: "Club ELD",
    sp_id: "237",
    methods: [
      {
        id: "98c36c9b-eeed-44f8-a3b2-ee4a925cad07",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://clubeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "cbe4d6c7-5729-4d6d-96c8-5c56a72e8d4e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://clubeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "370b6fea-b61f-4b31-9a3a-cb658bd6b145",
    const: EPlatformName.ELD_PRO_SOLUTION,
    value: "370b6fea-b61f-4b31-9a3a-cb658bd6b145",
    label: "ELD Pro Solution",
    sp_id: "238",
    methods: [
      {
        id: "6c8608c5-1cbd-4117-8ae2-03f0b043ddec",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://eldprosolution.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "77bd752f-fdd8-43d0-88be-bc4575c231fc",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://eldprosolution.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8809bec1-93f5-4ac2-a865-e5719ac523b9",
    const: EPlatformName.PROTRACKING_ELD,
    value: "8809bec1-93f5-4ac2-a865-e5719ac523b9",
    label: "ProTracking ELD",
    sp_id: "239",
    methods: [
      {
        id: "f0fbce39-6af3-4034-b3e3-286524327465",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://protrackingeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "f0a46772-4c01-4616-b4ed-99f4dedbfaa1",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://protrackingeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "910e78ee-50fa-4704-bb13-b51c1f246fd8",
    const: EPlatformName.SHARP_ELD,
    value: "910e78ee-50fa-4704-bb13-b51c1f246fd8",
    label: "Sharp ELD",
    sp_id: "240",
    methods: [
      {
        id: "6a2b22b2-de94-4528-8eb0-ad79c0f782a4",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://sharpeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "bf1c8375-3425-4358-b171-2a2596cd9e40",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://sharpeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "9adbe088-92e4-45f5-a21b-01f54b46b24b",
    const: EPlatformName.VISTA_ELD,
    value: "9adbe088-92e4-45f5-a21b-01f54b46b24b",
    label: "Vista ELD",
    sp_id: "241",
    methods: [
      {
        id: "fb625ce0-7173-44ee-92f4-4cb0e1fd49e9",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://vistaeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "c1a7d097-5d0a-420a-a573-c8f3720dbe8d",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://vistaeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e1d1d6e9-1dcd-4ef3-8509-ca1a909d1e42",
    const: EPlatformName.ZENITH_ELD,
    value: "e1d1d6e9-1dcd-4ef3-8509-ca1a909d1e42",
    label: "Zenith ELD",
    sp_id: "242",
    methods: [
      {
        id: "adfe51c7-a855-4814-867e-5b244e1350fe",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://zenitheld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "b07ba22f-0d36-44a9-9c65-210531e5e737",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://zenitheld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e5629713-5431-43f2-8cb6-0daf5ec8a132",
    const: EPlatformName.ADA_ELD,
    value: "e5629713-5431-43f2-8cb6-0daf5ec8a132",
    label: "ADA ELD",
    sp_id: "243",
    methods: [
      {
        id: "6972cbfe-2533-4b28-9c0e-b3cef599ac67",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://adaeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "28017737-2188-4931-b445-e16cd0715ca4",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://adaeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "18508d9c-1909-4c61-8d2e-8ee263af73b5",
    const: EPlatformName.ALFA_ELD,
    value: "18508d9c-1909-4c61-8d2e-8ee263af73b5",
    label: "Alfa ELD",
    sp_id: "403",
    methods: [
      {
        id: "90793c78-f70d-4c18-9b72-779e35051dd0",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://alfaeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "cd9ee68c-2dd7-4e07-9e3b-98cee905de0b",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://alfaeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "16f26fe3-d073-40e5-9ad7-ee152ef9302c",
    const: EPlatformName.ENSI_LOG,
    value: "cfb3b8be-d9ab-497e-bcd6-ffd9433974fe",
    label: "Ensi Log",
    sp_id: "561",
    methods: [
      {
        id: "496c72f1-a3bf-4032-b7a9-ec420383195d",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://ensilog.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "55000fa3-10f0-4710-9f46-df2d5230e199",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://ensilog.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e4c33846-2b23-4084-8e4d-3d33ffc59cfd",
    const: EPlatformName.INTERSTATE_FREEWAY,
    value: "95e4608d-2eb6-42c3-bef8-413cc3c7fdc4",
    label: "Interstate Freeway",
    sp_id: "562",
    methods: [
      {
        id: "0f041f5c-8998-49e0-a98a-7054cad4396e",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://interstatefreeway.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "70712466-9f4b-4343-886a-257bffc5ce22",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://interstatefreeway.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5140db95-8c53-41f3-9504-fe1d030720db",
    const: EPlatformName.SMART_ELOG,
    value: "174e750f-ddef-497b-8c73-a0de674c4097",
    label: "Smart Elog",
    sp_id: "563",
    methods: [
      {
        id: "9747c434-6bbd-46e2-8ff3-b06277d18489",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://smartelog.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "dd7c3fd1-fd87-47b2-bb72-010956e73a3f",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://smartelog.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2bf7c956-9d12-4aac-8a37-7445134e5729",
    const: EPlatformName.SPRINT_ELD,
    value: "b2225bf6-971d-4b96-b10a-42b8d281a652",
    label: "Sprint ELD",
    sp_id: "564",
    methods: [
      {
        id: "103cd648-60fb-429b-8cc2-663268b401eb",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://sprinteld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "ed7620fd-deff-4d03-b20c-b25703d91128",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://sprinteld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "dd3d8e19-d142-406e-aac9-7d324c00836e",
    const: EPlatformName.TRIP_ELD,
    value: "b59b92e0-9656-4df4-b5b8-500236efbf7c",
    label: "Trip ELD",
    sp_id: "565",
    methods: [
      {
        id: "c094062d-33a0-4bff-b5b8-0f219b35227d",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://tripeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "9bfa1ef2-9c73-49af-a053-9cc7d73d9964",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://tripeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "106b4431-25ce-44cc-9d5d-1491e377409c",
    const: EPlatformName._24HOS_ELD,
    value: "78df8f00-ae1b-4384-a2b1-597896337073",
    label: "24HOS ELD",
    sp_id: "577",
    methods: [
      {
        id: "b67c1a1c-945c-4122-9e42-de098e0b2cab",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://24hoseld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "17ae4465-f1f7-4bed-94fb-a4f1a95c91ed",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://24hoseld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "306a5214-4432-46d4-86c3-1089b268bbdb",
    const: EPlatformName.FORTUNE_ELD,
    value: "997d8700-93ef-41af-b0c3-68bb4f2b2aec",
    label: "Fortune ELD",
    sp_id: "586",
    methods: [
      {
        id: "2f770db4-9d04-462d-b6e6-e5e4ab69d2da",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://fortuneeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "7b80d40e-8504-4a27-bac1-987e78b3686c",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://fortuneeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "56b2d9b8-bcae-4fc8-bfe2-10b223f55fa5",
    const: EPlatformName.ORION_ELD,
    value: "36e99e8d-f6a7-489a-99ec-fa99a2cda1e3",
    label: "Orion ELD",
    sp_id: "587",
    methods: [
      {
        id: "19199e67-2b62-4bce-b68f-35f46d39e074",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://orioneld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e30ffb6e-960b-496e-abbc-960d3757f0a6",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://orioneld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "6b478aed-6d81-46a3-b6f2-d5a308205a3b",
    const: EPlatformName.PHANTOM_ELD,
    value: "bcd004d8-276c-45a9-9ed7-63daabe29ed3",
    label: "Phantom ELD",
    sp_id: "588",
    methods: [
      {
        id: "003fe019-325d-4164-934b-07c1979d5911",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://phantomeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "1d06f8bc-3b7d-4c9d-bb36-3d368b348d3e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://phantomeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "63610636-34a1-4bee-9863-198641bc0eb7",
    const: EPlatformName.TRENDY_ELD,
    value: "523bdf30-aa16-4549-91b7-0ad25899ac1e",
    label: "Trendy ELD",
    sp_id: "589",
    methods: [
      {
        id: "5c257659-cec2-4ee9-b176-010d471d9120",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://trendyeld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "9be1cbc6-e8cc-4376-87a8-282be1df5d68",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://trendyeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "83c7d6bf-613d-45ed-84fc-86c7b2ae052c",
    const: EPlatformName.VECTOR_ELD,
    value: "daa58ce3-1c34-4506-9f75-ab8cdb9aa243",
    label: "Vector ELD",
    sp_id: "590",
    methods: [
      {
        id: "cc740109-2fc5-443b-860b-8fd5f97261e4",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://vectoreld.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "a96600de-5687-43c1-935b-b0ed29c86110",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://vectoreld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "76521943-6e6b-442d-ba12-87e933dfc9db",
    const: EPlatformName.WHEELS_ELOG,
    value: "1c4529a4-7f6b-41fe-ae94-eaf511f95230",
    label: "Wheels eLog",
    sp_id: "591",
    methods: [
      {
        id: "2de1f8e8-ef15-4eeb-b073-741d979d7fcf",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://wheelselog.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "bb82fa31-d132-4873-9699-e012cc876a19",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://wheelselog.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e2808555-9dbd-4201-bc66-7feb4231c31e",
    const: EPlatformName.FLEETHUNT,
    value: "da394148-e1fc-4912-9f61-e552f6d9ee3a",
    label: "Fleethunt",
    sp_id: "232",
    methods: [
      {
        id: "9946e3fb-a172-4086-bd1a-372d511b9cff",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://services.fleethunt.ca/v1",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "3aa26a82-d14d-44ab-81ec-ccba2b82fce5",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://services.fleethunt.ca/v1",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b744f00b-4975-4d16-b30f-a990dc20e907",
    const: EPlatformName.VOYOMOTIVE,
    value: "5e528e8a-ac88-4ef0-9411-511d9d65a9d4",
    label: "Voyomotive",
    sp_id: "296",
    methods: [
      {
        id: "id",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://prod001.voyomotive.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "08ccb2e5-4c00-4a15-ab3f-cc2268608517",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://prod001.voyomotive.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // Reliable ELD and resellers
  {
    key: "0a0e46d0-b995-4240-b09d-37cddf906663",
    const: EPlatformName.RELIABLE_ELD,
    value: "37e58b88-01fc-4e4c-b2b6-a5547cb406b3",
    label: "Reliable ELD",
    sp_id: "258",
    methods: [
      {
        id: "11a5e278-50af-47f8-86ba-0227d4aaa3ba",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://publicapi.reliableeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "87ee0646-9eb9-4a23-831a-a8d18604320a",
    const: EPlatformName.AT_ELD,
    value: "c8a3198e-906c-47d3-a3a4-ba262f7b67b1",
    label: "AT ELD",
    sp_id: "254",
    methods: [
      {
        id: "bab8f38b-a7a6-4dac-af77-57a883bb68f6",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://publicapi.ateld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "4639c74c-2ee2-4893-aa47-58afddeb4f9d",
    const: EPlatformName.MGK_ELD,
    value: "7391306b-ebf8-47fb-b03b-3f8360489f46",
    label: "MGK ELD",
    sp_id: "255",
    methods: [
      {
        id: "3b7349c1-baf2-4db8-a137-1386d5772cf1",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://publicapi.mgkeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "20d98439-add6-4c18-8e59-4a3d8dbb9edc",
    const: EPlatformName.NOOR_ELD_SOLUTION,
    value: "33fd447e-318d-4da1-ad97-064d24270182",
    label: "Noor ELD Solutions",
    sp_id: "256",
    methods: [
      {
        id: "f22ff5ae-f781-4c68-8911-fcaf6e0f37d0",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://publicapi.nooreldsolutions.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5b2d87ad-0493-4578-9345-1401d9e55dcf",
    const: EPlatformName.ORIENT_ELD,
    value: "99a30d58-4dd4-4fd7-8eb0-1476fe195a9d",
    label: "Orient ELD",
    sp_id: "257",
    methods: [
      {
        id: "19dbe73c-5c8d-4739-a402-e899a26d5742",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://publicapi.orienteld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "cc6880ec-67d1-422a-8ef0-3ea5469e8fe5",
    const: EPlatformName.AXION_ROUTE,
    value: "f6e6ce80-f1ef-4a46-8e2b-0e5d03301d51",
    label: "Axion Route",
    sp_id: "560",
    methods: [
      {
        id: "55e05d12-5f37-4e6b-be3d-8def2fb18a15",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://publicapi.axionroute.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // TT ELD resellers
  {
    key: "43de1caf-7f24-4530-a881-22716508702f",
    const: EPlatformName.TT_ELD,
    value: "fb97260c-5614-4ae5-bff9-e7e377b5fd74",
    label: "TT ELD",
    sp_id: "220",
    methods: [
      {
        id: "7a2ae39b-d3f6-4813-9751-344eb6dc0cea",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.tteld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "1dc68bf4-fdcc-49b5-a952-6809830d0a56",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.tteld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "6710fe22-bfcb-4c6c-b6dc-802b1a6d6a29",
    const: EPlatformName.EVO_ELD,
    value: "88c37cde-3042-47bb-ab5e-7e48cfed1e55",
    label: "Evo ELD",
    sp_id: "259",
    methods: [
      {
        id: "835d3bee-0ce7-45cb-a473-dece6c90dcbc",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.evoeld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "c19d86fc-5e05-4e19-87e1-4ba55b81d415",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.evoeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "250a66d1-20f7-4968-a144-040a762a8287",
    const: EPlatformName.ONTIME_LOGS,
    value: "9e2c46d6-f59f-4862-8765-32367e014b02",
    label: "Ontime Logs",
    sp_id: "260",
    methods: [
      {
        id: "6fb69e19-7281-4da4-b746-6419b830c229",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.tteld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "3344e7d1-1a25-425e-b741-b700af2fc0b0",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.tteld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "1c26cb1e-2b62-4809-a9e7-6ea537b3845a",
    const: EPlatformName.ZIPPY_ELD,
    value: "b7d04be6-29f9-435a-8b44-6de3959a8b2e",
    label: "Zippy ELD",
    sp_id: "261",
    methods: [
      {
        id: "e1512ea8-0b1f-40c8-8f75-6f320641df75",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.zippyeld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "327368f7-0c3f-470f-b75c-551fc10aaea9",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.zippyeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3da7c4c8-1716-4ce3-a18a-9c711c994af1",
    const: EPlatformName.ONTIME_ELD,
    value: "c29b288f-f1f4-4b81-9fa2-b210b363948d",
    label: "Ontime ELD",
    sp_id: "495",
    methods: [
      {
        id: "60a52f7e-5110-41c0-9bea-5953de9a66cf",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.tteld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "4b978245-3dbb-4c5e-b764-cbb03783fa61",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.tteld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "fe3e8c5d-066f-4470-8715-9e209a38370e",
    const: EPlatformName.FIVE_ELD,
    value: "24165c15-1800-48f6-93c2-33f4131f7930",
    label: "Five ELD",
    sp_id: "566",
    methods: [
      {
        id: "f521a256-0dbb-49ef-b34c-5b8ce1a487f7",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.fiveeld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "bca09b27-f416-47f4-b7e9-0b8b8b763ec6",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.fiveeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "0640884f-6576-4c99-997c-20bb8b23b5d0",
    const: EPlatformName.LOGFLEET_ELD,
    value: "0d9c6072-e96b-4162-a9e4-68cc9aec5191",
    label: "Logfleet ELD",
    sp_id: "567",
    methods: [
      {
        id: "b24d9b9d-ca3c-430e-b2b9-a0c2cad8c8a2",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.logfleeteld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "9f12ec12-9dd0-4fe5-b245-1e9af83895fa",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.logfleeteld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "3ad62b3f-ad36-4710-8c7d-18f05821d492",
    const: EPlatformName.SUN_ELD,
    value: "3a2d94c5-10f9-4742-85d1-f097bdebe318",
    label: "Sun ELD",
    sp_id: "575",
    methods: [
      {
        id: "9d0cc4ae-36d2-4064-b0d8-a82ee7aeea59",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.suneld.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "45d20430-270b-4179-bd6c-b3b367bd6704",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.suneld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b6816818-13c0-42bd-a277-fa5d1c4178e5",
    const: EPlatformName.FLEET_VISION,
    value: "61916d3e-0ec3-4cf1-ab6c-602e0b895bcd",
    label: "FleetVision",
    sp_id: "592",
    methods: [
      {
        id: "d26c2ea3-894a-423f-9e12-953da7b6043e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.fleetvision.com",
        fixed_url: true,
        check_connection: false,
      },
      {
        id: "6ebe327a-538c-4bb2-a53c-b5069b5f3449",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://read.fleetvision.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // Drive HOS resellers
  // {
  //   key: "e8ea85a0-8e92-44a5-a83d-aa9ae588852f",
  //   const: EPlatformName.DRIVE_HOS,
  //   value: "e8ea85a0-8e92-44a5-a83d-aa9ae588852f",
  //   label: "Drive HOS",
  //   sp_id: "188",
  //   methods: [
  //     {
  //       id: "4ba58b3f-c80a-4236-bed1-58aee345006e",
  //       authorityType: EAuthTypes.ACCOUNT,
  //       type: ETelematicsMethodType.MANUAL,
  //       url: "https://api.drivehos.app",
  //       fixed_url: true,
  //       check_connection: false,
  //     },
  //   ],
  // },
  {
    key: "8a180c62-9474-477d-804c-9c1c33056760",
    const: EPlatformName.FACTOR_ELD,
    value: "8a180c62-9474-477d-804c-9c1c33056760",
    label: "Factor ELD",
    sp_id: "161",
    methods: [
      {
        id: "82ee86d8-b250-4bd4-88bf-af857367860e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c10d9256-cd93-4909-9f79-bb382a5e5c11",
    const: EPlatformName.DAILY_ELD_PLUS,
    value: "c10d9256-cd93-4909-9f79-bb382a5e5c11",
    label: "Daily ELD Plus",
    sp_id: "189",
    methods: [
      {
        id: "5360875b-9e40-42e2-8df7-96ec57f114c7",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b196fa88-419a-463b-8ebb-ddffca85148a",
    const: EPlatformName.DSG_LOGS,
    value: "b196fa88-419a-463b-8ebb-ddffca85148a",
    label: "DSG Logs",
    sp_id: "190",
    methods: [
      {
        id: "6702a1c7-e35f-4fab-9d03-d116c8d676cc",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d2c62afa-0d5f-47f9-8963-4b4e019dfb67",
    const: EPlatformName.DY_PLUS_ELD,
    value: "d2c62afa-0d5f-47f9-8963-4b4e019dfb67",
    label: "DY Plus ELD",
    sp_id: "191",
    methods: [
      {
        id: "27e50832-3acb-4660-9c08-6302dde1092e",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "47b384de-5d36-4e97-9bad-6f35a33ba456",
    const: EPlatformName.EGREEN_ELD_PRO,
    value: "47b384de-5d36-4e97-9bad-6f35a33ba456",
    label: "EGreen ELD Pro",
    sp_id: "192",
    methods: [
      {
        id: "bdb4c2fd-0133-40ab-ae9a-3b82386695a3",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "76a7877e-2755-4cec-8dfe-0835547311da",
    const: EPlatformName.UZBPRIME_ELD,
    value: "76a7877e-2755-4cec-8dfe-0835547311da",
    label: "UZBPrime ELD",
    sp_id: "193",
    methods: [
      {
        id: "da31e8fd-a701-4efd-856c-d49f37cac845",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8166ec10-d172-4526-88e8-1e8c4eabb7ce",
    const: EPlatformName.ILOG_ELD_APP,
    value: "8166ec10-d172-4526-88e8-1e8c4eabb7ce",
    label: "ILog ELD App",
    sp_id: "194",
    methods: [
      {
        id: "6ec39725-217a-423d-9dde-503a2133db23",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c2c9f7b1-cba2-43dc-a0cd-cc5c406c190b",
    const: EPlatformName.LEADER_ELD,
    value: "c2c9f7b1-cba2-43dc-a0cd-cc5c406c190b",
    label: "Leader ELD",
    sp_id: "195",
    methods: [
      {
        id: "c7c740f6-3d38-48f3-bdd2-13bba833153a",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "65013a44-a5ec-41b1-8a5e-7b64dfa4c7ae",
    const: EPlatformName.LUCID_ELD,
    value: "65013a44-a5ec-41b1-8a5e-7b64dfa4c7ae",
    label: "Lucid ELD",
    sp_id: "196",
    methods: [
      {
        id: "5d7054ca-fd57-4a02-8f50-a26e8469bee2",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ab6fe709-09fe-436f-bea0-127cffb2b409",
    const: EPlatformName.PANDA_ELD,
    value: "ab6fe709-09fe-436f-bea0-127cffb2b409",
    label: "Panda ELD",
    sp_id: "197",
    methods: [
      {
        id: "c9856044-1def-4229-b8ad-1a18d5dd7bbb",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b5d66fb5-fb16-4513-bd14-4743efb320bb",
    const: EPlatformName.PRESTIGE_ELD,
    value: "b5d66fb5-fb16-4513-bd14-4743efb320bb",
    label: "Prestige ELD",
    sp_id: "198",
    methods: [
      {
        id: "634b500e-0d4a-4cbe-8bac-4ee6a1bf4c1c",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8eb9f73a-d28f-4b85-984f-22dc84858dfa",
    const: EPlatformName.STARTRUCKS_ELD,
    value: "8eb9f73a-d28f-4b85-984f-22dc84858dfa",
    label: "StarTrucks ELD",
    sp_id: "199",
    methods: [
      {
        id: "a8c5cfcc-499b-452a-b7e4-19ea08bbbe66",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b33dbaed-272f-498c-8958-e977314eeca9",
    const: EPlatformName.US_FAST_ELD,
    value: "b33dbaed-272f-498c-8958-e977314eeca9",
    label: "US Fast ELD",
    sp_id: "203",
    methods: [
      {
        id: "6c4082df-0227-4c53-ab22-0daa986cd156",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "7b37a43c-c3b5-4f3e-a073-b8f54f0e43d4",
    const: EPlatformName.US_POWER_ELD,
    value: "7b37a43c-c3b5-4f3e-a073-b8f54f0e43d4",
    label: "US Power ELD",
    sp_id: "206",
    methods: [
      {
        id: "c3328c14-ec2e-4b24-b692-287024007365",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "6506b2df-eb2d-41fd-8da8-a24cf00ebda9",
    const: EPlatformName.VITALITY_ELD,
    value: "6506b2df-eb2d-41fd-8da8-a24cf00ebda9",
    label: "Vitality ELD",
    sp_id: "207",
    methods: [
      {
        id: "9720eb16-b43b-41c5-9173-ad91a727802b",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "cb1ca228-d142-4bc9-b2a1-301af38c85bc",
    const: EPlatformName.ZEROMAX_ELD,
    value: "cb1ca228-d142-4bc9-b2a1-301af38c85bc",
    label: "Zeromax ELD",
    sp_id: "231",
    methods: [
      {
        id: "b8de2d72-667e-4d07-a091-2e7f54ed72fd",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "663ae809-504c-4fc8-b320-cab09490910c",
    const: EPlatformName.BLUE_STAR_ELD,
    value: "663ae809-504c-4fc8-b320-cab09490910c",
    label: "Blue Star ELD",
    sp_id: "392",
    methods: [
      {
        id: "b3d041d8-dcb0-4f98-b92b-6d0e3fce850f",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e208081a-6065-4cb5-9533-a54426657e63",
    const: EPlatformName.SECURE_PATH_ELD,
    value: "e208081a-6065-4cb5-9533-a54426657e63",
    label: "Secure Path ELD",
    sp_id: "393",
    methods: [
      {
        id: "67ff2edf-7372-4ef2-9bdc-d671e8ee5245",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8d99ebab-f112-489d-b343-570373336924",
    const: EPlatformName.FIRST_ELD,
    value: "840d4014-6c1d-4638-973f-6ad82ef2913f",
    label: "First ELD",
    sp_id: "482",
    methods: [
      {
        id: "f7ab09f1-e0f6-47bb-b108-ad84c0fb5f39",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "439b8e7c-f459-4be8-ba75-ebc1c795f459",
    const: EPlatformName.DRIVE_LENS_ELD,
    value: "c73a874d-d685-48c5-8995-6b6f71e40066",
    label: "Drive Lens ELD",
    sp_id: "571",
    methods: [
      {
        id: "f9ea2d67-e286-49c3-8942-a8386361bb59",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "04b0ef02-ef4f-4ea0-96db-df7bbec4ec98",
    const: EPlatformName.NIGHT_WATCH_ELD,
    value: "5f6a69ae-5569-4393-8d53-b9815e88ab6c",
    label: "Night Watch ELD",
    sp_id: "572",
    methods: [
      {
        id: "bbf273b2-02a2-4703-8d97-e4cc4af99a6c",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8e858d51-3ba5-4949-a07e-4f8b1ea60574",
    const: EPlatformName._ELD88,
    value: "6eb26a2c-5bd9-4338-9c34-ceac6527c10f",
    label: "ELD88",
    sp_id: "593",
    methods: [
      {
        id: "3960e724-b0d9-4be8-a4c5-4d1a0e77a366",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api-eld88.mycloudeld.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "e0c46968-a32f-4a99-a2fa-e307eafa5fb1",
    const: EPlatformName.AFS_WORLD_ELD,
    value: "32925e60-4c40-4c4f-9ee0-48ae77bcde57",
    label: "AFS World ELD",
    sp_id: "594",
    methods: [
      {
        id: "a561a134-6e50-43a1-a9b0-d00c50b4dac0",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "29c84c0e-2796-4781-8087-aa3d88e96f34",
    const: EPlatformName.HUNTER_ELD,
    value: "557f89dc-5c36-4a2e-bd92-507a98659c62",
    label: "Hunter ELD",
    sp_id: "595",
    methods: [
      {
        id: "05395cdc-019a-45cb-8054-45174c04b852",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "ae44e32f-c0b3-42b1-ae72-8e23cf32a621",
    const: EPlatformName.REMAX_ELD,
    value: "9c0fda20-a596-4057-babf-54e3ead4cf60",
    label: "Remax ELD",
    sp_id: "596",
    methods: [
      {
        id: "f01923a7-4389-404d-814d-a19fdcce23f9",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://api.drivehos.app",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // EzToTrack
  {
    key: "57178844-77ab-48f7-bb4d-80a4cdf356ae",
    const: EPlatformName.EZ_TO_TRACK,
    value: "57178844-77ab-48f7-bb4d-80a4cdf356ae",
    label: "EzToTrack",
    sp_id: "517",
    methods: [
      {
        id: "9c4d5e78-c7c3-483f-a783-c5168fcb91b5",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "584907b7-4ad1-4c78-9929-b18a3b25a06e",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  // EzToTrack resellers
  {
    key: "fe2c43ca-e5cc-4396-8f7f-3ad7c9676e25",
    const: EPlatformName.GOOD_DEAL_GPS,
    value: "fe2c43ca-e5cc-4396-8f7f-3ad7c9676e25",
    label: "Good Deal GPS",
    sp_id: "518",
    methods: [
      {
        id: "862163f9-1479-4a74-a165-f2ea8414eb62",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "81f2f1e4-c33b-44e6-96e0-5c6694ae939b",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "39b4e036-fa6b-4fb1-b392-79c29a8f5584",
    const: EPlatformName.HOS_ELD,
    value: "39b4e036-fa6b-4fb1-b392-79c29a8f5584",
    label: "HOS ELD",
    sp_id: "519",
    methods: [
      {
        id: "fb427541-487a-42ba-9296-833e8c6b7369",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "37b0cd66-e2a2-40c2-877c-9477088f41c0",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "b7e4e6bd-d31b-4199-b5df-bf77818e6f2b",
    const: EPlatformName.TRANSIT_TRACKING,
    value: "b7e4e6bd-d31b-4199-b5df-bf77818e6f2b",
    label: "Transit Tracking",
    sp_id: "520",
    methods: [
      {
        id: "29081e7f-39a7-4508-8716-3ba1535f84ae",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "18a91db7-178d-4025-a20a-43fcf62acb29",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "25d1a481-72d7-4a0a-a2d1-984d0bd84b42",
    const: EPlatformName.MT_ELD,
    value: "25d1a481-72d7-4a0a-a2d1-984d0bd84b42",
    label: "MT ELD",
    sp_id: "521",
    methods: [
      {
        id: "0a0921b0-b2f8-4838-a054-1c673b50d067",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "c37bd6e2-49a5-43db-9b6e-70671a73f147",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "153010de-3b3c-402a-b2b6-44d1e91c6ea6",
    const: EPlatformName.EAGLE_ELD,
    value: "153010de-3b3c-402a-b2b6-44d1e91c6ea6",
    label: "Eagle ELD",
    sp_id: "522",
    methods: [
      {
        id: "4e43c7f0-aa6d-48e2-ab6b-8b2191f0c51e",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "85ae3175-0697-476c-bc57-e1f96c4ebee2",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "1562083a-6e4e-4e8e-b80e-19a412117378",
    const: EPlatformName.SMART_WAY_ELD,
    value: "1562083a-6e4e-4e8e-b80e-19a412117378",
    label: "Smart Way ELD",
    sp_id: "523",
    methods: [
      {
        id: "f1502b29-25cf-4b62-8ff5-7598cf17b068",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "5d91929f-5e0a-4205-b514-44922bf65a00",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f3c5927b-3999-4b7c-8f8f-39c3fc0ac3bd",
    const: EPlatformName.OXEMON,
    value: "f3c5927b-3999-4b7c-8f8f-39c3fc0ac3bd",
    label: "Oxemon",
    sp_id: "524",
    methods: [
      {
        id: "72400b36-4fb3-4d02-b6ac-604de51c22e4",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "339b4edd-ad3a-4cd9-ab2d-9a77d9421dc6",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "8efff4f6-fbb7-4217-925b-a227b4971c62",
    const: EPlatformName.ROUTELINK_IO,
    value: "8efff4f6-fbb7-4217-925b-a227b4971c62",
    label: "Routelink IO",
    sp_id: "525",
    methods: [
      {
        id: "4f128fed-2d8b-4b04-94ce-d5ba9aeb0456",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "62e90863-f9fe-4fa5-a4b1-4b72af1b1311",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c85cbd1b-696e-47ab-ad3b-98b49e3c67ba",
    const: EPlatformName.ELD4_TRUCKS,
    value: "c85cbd1b-696e-47ab-ad3b-98b49e3c67ba",
    label: "ELD4 Trucks",
    sp_id: "526",
    methods: [
      {
        id: "f353b511-3e3f-489e-be53-e0c72a0f6f1a",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "3a494271-6074-402f-a93f-2e620e30cd6f",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "09bc75be-eede-43bc-a082-c02e6b36f708",
    const: EPlatformName.ATINA_ELD,
    value: "09bc75be-eede-43bc-a082-c02e6b36f708",
    label: "Atina ELD",
    sp_id: "527",
    methods: [
      {
        id: "061a8032-c6d3-40dd-abb8-29cc7ab2f616",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "21c3f3aa-8485-4b22-a8b5-2cd333284c70",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "f53f21fb-c521-472c-adec-b7f3c6738e44",
    const: EPlatformName.UNIFY_ELD,
    value: "f53f21fb-c521-472c-adec-b7f3c6738e44",
    label: "Unify ELD",
    sp_id: "528",
    methods: [
      {
        id: "ae5d6a00-f038-45ef-86c9-f9f691612d78",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "4d1ee545-bfa2-4d2c-9faa-a371d39bf661",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "d8f593f9-61dd-4b0c-a0d9-c626fe259c3a",
    const: EPlatformName.ELD_RUN,
    value: "d8f593f9-61dd-4b0c-a0d9-c626fe259c3a",
    label: "ELD Run",
    sp_id: "529",
    methods: [
      {
        id: "e33c0a0e-46f2-4b1d-b7e2-7e3c0987ad36",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e2ea620e-8478-4543-bdfe-a892fd7e6857",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "61d08cd3-d95e-4566-a574-068cabe75ab0",
    const: EPlatformName.TERA_HUB,
    value: "61d08cd3-d95e-4566-a574-068cabe75ab0",
    label: "Tera Hub",
    sp_id: "530",
    methods: [
      {
        id: "ff1a146d-c9d0-4d4a-a4af-bc94e48e0126",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "c1034c7f-3d2c-4e44-876b-8b1e63fdaa73",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "686d0a17-0141-4efe-8908-3ed2b8f3704e",
    const: EPlatformName.HOBBS_ELD,
    value: "686d0a17-0141-4efe-8908-3ed2b8f3704e",
    label: "Hobbs ELD",
    sp_id: "531",
    methods: [
      {
        id: "267d0827-a0bc-4789-a969-0422cf68a23c",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "a6f2dc35-ade1-4c9c-9daa-de5ef4b487c3",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "c80bef23-2104-4a99-9d1b-6979bb463c32",
    const: EPlatformName.PINNACLE_ELD,
    value: "c80bef23-2104-4a99-9d1b-6979bb463c32",
    label: "Pinnacle ELD",
    sp_id: "532",
    methods: [
      {
        id: "7d956f4e-2758-42df-816b-3de55fe19dcb",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "9f959e57-d716-4555-8c30-0c92dcba8fba",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "eef7cd1c-9f76-4814-94cc-1d4e4d5f1ace",
    const: EPlatformName.MEMENTO_ELD,
    value: "eef7cd1c-9f76-4814-94cc-1d4e4d5f1ace",
    label: "Memento ELD",
    sp_id: "533",
    methods: [
      {
        id: "e9ffd343-cfa0-45d9-b160-bf86af91fde7",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "8a3c408b-bf99-4456-a423-4fbef2dfbd94",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "402af4b5-e210-46f1-84ec-d19ec0b5b7e9",
    const: EPlatformName.HORIZONT_PATH_ELD,
    value: "402af4b5-e210-46f1-84ec-d19ec0b5b7e9",
    label: "Horizont Path ELD",
    sp_id: "534",
    methods: [
      {
        id: "c9ece6c5-ccde-44c8-8089-3a6d94494b5c",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "e6c6f025-4b5e-4b03-85f1-24fec5de68ce",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5f661606-afa6-409f-b37c-ceba33b23622",
    const: EPlatformName.NOMAD_ELD,
    value: "5f661606-afa6-409f-b37c-ceba33b23622",
    label: "Nomad ELD",
    sp_id: "535",
    methods: [
      {
        id: "c724f615-cf61-427e-a2e3-3adc22530522",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "36d24398-1ba4-4493-924e-e420e87330d3",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://integration.app.eztotrack.com",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5849fc33-8aea-42d8-a939-bdbc0b8d4a41",
    const: EPlatformName.TXT_ELD,
    value: "5849fc33-8aea-42d8-a939-bdbc0b8d4a41",
    label: "TXT ELD",
    sp_id: "458",
    methods: [
      {
        id: "20d879b3-a918-4c5f-bb2a-a7d3db162f0d",
        authorityType: EAuthTypes.ACCOUNT,
        type: ETelematicsMethodType.MANUAL,
        url: "https://ws-dash.txtesolutions.com/api",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "5305a7dd-59cf-4707-9041-2035953e5df6",
    const: EPlatformName.PAYD_ELD,
    value: "5305a7dd-59cf-4707-9041-2035953e5df6",
    label: "PAYD ELD",
    sp_id: "580",
    methods: [
      {
        id: "8ac482bf-3528-435b-a8cb-b691e1612dc1",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://paydapi.hutchsystems.com/HutchClientAPI.svc",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "45450c1e-6c48-4cd7-a187-d56925757bab",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://paydapi.hutchsystems.com/HutchClientAPI.svc",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
  {
    key: "2c275410-ca96-4d5e-afe9-a62713ff7f95",
    const: EPlatformName.HUTCH_SYSTEMS,
    value: "2c275410-ca96-4d5e-afe9-a62713ff7f95",
    label: "Hutch Systems",
    sp_id: "579",
    methods: [
      {
        id: "c8778ade-a01f-4201-ae73-0041c1337436",
        authorityType: EAuthTypes.TOKEN,
        type: ETelematicsMethodType.PERMANENT_API,
        url: "https://hutchservice.hutchsystems.com/HutchAppAPI.svc",
        fixed_url: true,
        check_connection: true,
      },
      {
        id: "737b3e16-574d-4d50-95d1-cb04e2df6721",
        authorityType: EAuthTypes.BASIC,
        type: ETelematicsMethodType.MANUAL,
        url: "https://hutchservice.hutchsystems.com/HutchAppAPI.svc",
        fixed_url: true,
        check_connection: false,
      },
    ],
  },
];
